document.addEventListener('DOMContentLoaded', function () {

    const GUEST_WORD_LIMIT = Number(window.APP_LIMITS?.guestWordLimit ?? 3000);
    const USER_WORD_LIMIT = Number(window.APP_LIMITS?.userWordLimit ?? 10000);
    const REQUEST_WORD_LIMIT = isLoggedIn ? USER_WORD_LIMIT : GUEST_WORD_LIMIT;

    // The page language's grouping (partial/number-format.blade.php) — the
    // same the server prints the limits beside these counters with.
    function formatCount(value) {
        return window.formatNumber ? window.formatNumber(value) : String(value);
    }

    setTimeout(function() {
        const stickyGradient = document.querySelector('.sticky-gradient');
        if (stickyGradient) {
            stickyGradient.style.height = '400px';
        }
    }, 100)

    if (isLoggedIn) {
        fetch('/refresh-user-limit', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Unable to refresh user limit (${response.status})`);
                }
                return response.json();
            })
            .then(data => {
                if (data.remaining_words !== undefined) {
                    const leftLimit = document.getElementById('leftLimit');
                    if (leftLimit) leftLimit.textContent = formatCount(data.remaining_words.daily);
                    const used = fullLimit - (+data.remaining_words.daily);
                    const percentage = 100 - ((used / fullLimit) * 100);
                    const ring = document.getElementById("userProgressRing");
                    ring?.style.setProperty("--percentage", percentage);
                }
            })
            .catch(console.error);
    }

    // loader
    const loaderContainer = document.getElementById('loaderContainer');
    const loadingText = document.getElementById('loadingText');
    let cleanText = '';
    let originalHtmlText = '';
    let dzInstance = null;

    const phrases = [
        __('content.loader_refine'),
        __('content.loader_analyz'),
        __('content.loader_enhanc'),
        __('content.loader_optimize'),
        __('content.loader_finalize')
    ];

    let interval, phraseIndex = 0;
    let progressRaf = null;
    const easeOutCubic = x => 1 - Math.pow(1 - x, 3);

    function getTimes(typeGeneration, wordsCount, lang) {

        const factor = lang === 'English' ? 1 : 2;

        const ranges = typeGeneration == 'generation' ? [
            { max: 500, anim: 20 * factor + 's', words: 20 * factor + ' s' },
            { max: 1000, anim: 40 * factor + 's', words: 40 * factor + ' s' },
            { max: 2000, anim: 60 * factor + 's', words: (factor === 1 ? '1 min' : '2 min') },
            { max: Infinity, anim: 120 * factor + 's', words: (factor === 1 ? '2 min' : '4 min') },
        ] : (typeGeneration == 'grammar' || typeGeneration == 'paraphraser') ? [
            { max: 800, anim: '15s', words: '15 s' },
            { max: 2000, anim: '20s', words: '20 s' },
            { max: 4000, anim: '30s', words: '30 s' },
            { max: Infinity, anim: '40s', words: '40 s' },
        ] : [
            // Humanizer estimates, raised by a third over the previous
            // 15 / 35 / 75 and rounded to whole numbers: the runs were
            // finishing after the bar had already filled.
            { max: 500, anim: '20s', words: '20 s' },
            { max: 1000, anim: '45s', words: '45 s' },
            { max: 3000, anim: '100s', words: '100 s' },
            { max: Infinity, anim: '100s', words: '100 s' },
        ];

        const found = ranges.find(r => wordsCount <= r.max);

        return {
            timeAnim: found?.anim ?? '60s',
            timeWords: found?.words ?? '1 min'
        };
    }


    /** Fills in the estimate labels and returns the run's duration in ms. */
    function fillOneMinute(typeGeneration, wordsCount, lang) {
        const bar = document.getElementById('minuteProgress');
        if (bar) {
            // No CSS transition: the track is driven per frame from elapsed time
            // (see startProgress), as in the design sample.
            bar.style.transition = 'none';
            bar.style.width = '0%';
        }

        const { timeAnim, timeWords } = getTimes(typeGeneration, wordsCount, lang);
        const loadingTimeLabel = document.querySelector('#loaderContainer .loading-time-label');
        const timeCount = document.getElementById('timeCount');

        if (loadingTimeLabel) {
            loadingTimeLabel.innerText = `${__('content.loader_estimating_time').trim()} `;
        }

        if (timeCount) {
            timeCount.innerText = timeWords;
        }

        return (parseFloat(timeAnim) || 60) * 1000;
    }

    /**
     * rAF-driven, time-eased progress, as in the sample. The percentage used to be
     * measured off the track's own width while one long CSS transition animated it
     * — so whenever that transition could not start (the element is still hidden
     * when the width is set, or the viewer has "reduce motion" on, which our own
     * async.css enforces with `transition: none !important`) the track snapped to
     * full and the readout showed 99% the moment the loader appeared.
     */
    function startProgress(durationMs) {
        stopProgress();

        const bar = document.getElementById('minuteProgress');
        const pctEl = document.getElementById('loaderPercent');
        const started = performance.now();
        let lastPct = -1;

        const frame = now => {
            const t = Math.min(1, (now - started) / durationMs);
            // stop just short of 100: the run is done when the result lands
            const value = easeOutCubic(t) * 99;
            if (bar) bar.style.width = value + '%';

            const pct = Math.round(value);
            if (pct !== lastPct) {
                lastPct = pct;
                if (pctEl) pctEl.innerText = pct + '%';
                if (pct >= 20 && phraseIndex === 0) { loadingText.innerText = phrases[1]; phraseIndex++; }
                else if (pct >= 40 && phraseIndex === 1) { loadingText.innerText = phrases[2]; phraseIndex++; }
                else if (pct >= 60 && phraseIndex === 2) { loadingText.innerText = phrases[3]; phraseIndex++; }
                else if (pct >= 80 && phraseIndex === 3) { loadingText.innerText = phrases[4]; phraseIndex++; }
            }

            if (t < 1) progressRaf = requestAnimationFrame(frame);
        };

        progressRaf = requestAnimationFrame(frame);
    }

    function stopProgress() {
        if (progressRaf) cancelAnimationFrame(progressRaf);
        progressRaf = null;
    }

    function retryProgressMessage(progress) {
        const attempt = Math.max(1, Number(progress?.attempt) || 1);
        if (attempt === 1) return __('content.loader_improving_first');
        if (attempt === 2) return __('content.loader_improving_again');
        return __('content.loader_improving_more');
    }

    function restartLoaderForProgress(progress, typeGeneration, wordsCount, lang) {
        const durationMs = fillOneMinute(typeGeneration, wordsCount, lang);
        const loaderPercent = document.getElementById('loaderPercent');
        if (loaderPercent) loaderPercent.innerText = '0%';
        loadingText.innerText = retryProgressMessage(progress);
        phraseIndex = phrases.length;
        startProgress(durationMs);
    }

    /* Phones and stacked tablets: the result panel sits below the input, so
       the run would happen off-screen. The panel is brought into view twice -
       when the run starts (to show the progress bar) and again when the
       result lands. The double rAF matters: on the first run the panel is
       revealed (has-run) in the same tick, and a same-tick scrollIntoView
       still measures it as display:none — that is the "scrolls only the
       second time" bug of the static demos. */
    function scrollToResultPanel(panel, toHead) {
        if (!panel || !matchMedia('(max-width: 900px)').matches) return;
        const align = () => {
            const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            // Keep the guest strip above the result clear of the sticky header.
            // Resolve it after layout: the result event reveals it in this tick.
            const banner = panel.previousElementSibling;
            const shownBanner = banner?.matches('.si-bar-mid:not([hidden])') ? banner : null;
            const pinned = shownBanner && getComputedStyle(shownBanner).position === 'fixed';
            const target = pinned ? panel : (shownBanner || panel);
            /* A pinned strip is always "in view", so scrolling to it does
               nothing. Park the panel's top exactly against the strip's
               bottom edge — measured, not a constant: a guessed offset
               left a sliver of the Humanize button glowing above the
               result, which is what the strip is meant to cover. Without
               a strip the panel's own scroll margin clears the header. */
            const clearance = pinned
                ? shownBanner.getBoundingClientRect().bottom
                : (parseFloat(getComputedStyle(target).scrollMarginTop) || 0);
            let top = target.getBoundingClientRect().top + window.scrollY - clearance;
            /* ...but never past the bottom of the panel itself. While the
               run is going the panel is only a loader box: parked under the
               header, it left the rest of the screen to the page under the
               card, and the result's height then moved all of that in view
               (field CLS, Oct 2026), while the blank it used to leave looked
               as if something had broken. The screen's bottom edge stops a
               hair under the panel's: the disclaimer and the page under the
               card start just below the fold, in reach of a flick, and are
               not counted when the result's height moves them further down.
               The panel head is still in view, lower. The result itself is
               read from its head: that call parks the head under the
               header, whatever the panel's height (Oct 2026 review). */
            /* A phone panel has the height of the finished result from the
               tap on (the reserves in async.css), so there is no loader box
               to park by its bottom edge: the head goes under the header on
               the tap, where the result is read from, and the result needs
               no scroll of its own - one move, not a dip and a climb (Oct
               2026 review) */
            if (!toHead && !matchMedia('(max-width: 900px)').matches) {
                const panelBottom = panel.getBoundingClientRect().bottom + window.scrollY;
                top = Math.min(top, panelBottom - 2 - window.innerHeight);
            }
            /* already there (the second pass, with no keyboard to close):
               a smooth scroll restarted on the spot was reported as a shift
               of the panel by the layout-shift tracker, 0.01 a run */
            if (Math.abs(Math.max(0, top) - window.scrollY) < 2) return;
            window.scrollTo({ top: Math.max(0, top), behavior });
        };
        requestAnimationFrame(() => requestAnimationFrame(align));
        /* the closing phone keyboard resizes the viewport mid-scroll and the
           first pass can land short — settle again once the resize is over,
           unless the user has taken over the scroll by then */
        let userTookOver = false;
        const cancel = () => { userTookOver = true; };
        addEventListener('touchstart', cancel, { once: true, passive: true });
        addEventListener('wheel', cancel, { once: true, passive: true });
        setTimeout(() => {
            removeEventListener('touchstart', cancel);
            removeEventListener('wheel', cancel);
            if (!userTookOver) align();
        }, 600);
    }

    /* When the run finishes, a phone re-aligns on the result panel and a
       desktop scrolls the whole tool block under the header instead: there
       the panel sits beside the input, and the banner below the result was
       ending up under the fold. */
    function scrollToFinishedResult(panel) {
        if (!panel) return;
        // a stacked layout parked the head on the tap (scrollToResultPanel)
        if (matchMedia('(max-width: 900px)').matches) return;
        const tool = panel.closest('.tool');
        if (!tool) return;
        /* the header is two floors tall now: measured, so the tool's own tab
           row stays in view under it (tester, Oct 2026) */
        const headerHeight = document.getElementById('header')?.getBoundingClientRect().height || 60;
        const top = tool.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({
            top: Math.max(0, top),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    }

    /* A re-run on a stacked layout keeps the result panel at the height of
       the result it replaces, measured before the submit empties it: the
       next result lands in the same room, so the page under the card has no
       reason to move, and the panel's head can be parked under the header
       right away - one scroll, not a dip to the loader box and a climb back
       when the result is in (Oct 2026 review). Let go in settleResultPanel. */
    function holdResultPanel(panel) {
        if (!panel || !matchMedia('(max-width: 900px)').matches) return;
        if (!panel.closest('.tool')?.classList.contains('has-run')) return;
        const height = Math.round(panel.getBoundingClientRect().height);
        if (height > 0) panel.style.minHeight = `${height}px`;
    }

    function showLoader(typeGeneration='humanize', wordsCount=0, lang='English') {
        const durationMs = fillOneMinute(typeGeneration, wordsCount, lang);
        // Show the loader in the result panel (right side), per the new design
        if(typeGeneration == 'generation') {
            document.querySelector('#AIWriter .writer-body').append(loaderContainer);
        } else {
            /* Right under the panel's head: on stacked layouts the loader
               stands in the panel's flow (async.css), with a skeleton of the
               result under it, so the order in the DOM is the order on the
               screen. The desktop overlay is absolute and does not care. */
            const pane = typeGeneration == 'grammar' ? '#GrammarChecker'
                : typeGeneration == 'paraphraser' ? '#AIParaphraser' : '#AIHumanizer';
            const panel = document.querySelector(pane + ' .humanResult');
            const head = panel.querySelector(':scope > .output-header');
            if (head) head.after(loaderContainer); else panel.append(loaderContainer);
            panel.querySelector(':scope > .sk-stack')?.remove();
            loaderContainer.after(resultSkeleton(typeGeneration));
        }

        loaderContainer.style.display = 'flex';
        // mobile shows the result panel only after the first run (CSS hides it
        // on .tool:not(.has-run))
        const tool = loaderContainer.closest('.tool');
        // a re-run holds the panel's height (holdResultPanel, on the submit)
        const rerunPanel = loaderContainer.closest('.humanResult, .writer-body');
        const rerun = !!(rerunPanel && rerunPanel.style.minHeight);
        tool?.classList.add('has-run');
        // the phone panel gives the loader room while the run is on (async.css)
        tool?.classList.add('is-running');
        /* The checker's and the paraphraser's phone reserve: their result
           is about as long as the text that went in, so the panel takes the
           input's rendered height plus the panel's own chrome (score card,
           filters, refine row, footer) from the tap on - a short text gets
           a short panel, a long one the screen under the header, past
           which the result grows below the fold. The humanizer's reserve
           is the designer's fixed one (async.css). */
        if (!rerun && rerunPanel && matchMedia('(max-width: 900px)').matches
            && (typeGeneration === 'grammar' || typeGeneration === 'paraphraser')) {
            const source = rerunPanel.parentElement?.querySelector('.quill-editor-container .ql-editor');
            const textHeight = source ? source.scrollHeight : 0;
            const chrome = typeGeneration === 'grammar' ? 470 : 340;
            const reserve = Math.min(window.innerHeight - 74, Math.max(380, chrome + textHeight));
            rerunPanel.style.minHeight = `${Math.round(reserve)}px`;
        }
        /* a re-run must leave the result layout: .has-result caps the panes
           with min-height:0/overflow:hidden, and against the absolute loader
           overlay they collapse — the loader landed on the panel head/footer */
        tool?.classList.remove('has-result');
        /* the run has started, so the previous result must go with it:
           writing-tools.js empties its score strip, filters and detail blocks.
           Left standing they sit behind the loader overlay and show their
           borders under the progress bar */
        window.dispatchEvent(new CustomEvent('writing-tool:run', { detail: { type: typeGeneration } }));
        // the sign-in strip and the thumbs belong to the previous result
        window.dispatchEvent(new CustomEvent('upsell:cleared'));
        // ...but the strip itself takes its place now, on the user's tap
        window.dispatchEvent(new CustomEvent('upsell:start'));
        /* A fresh run starts collapsed again on phones (see applyResultClamp),
           and the "Show all" strip goes with the result it belonged to: left
           standing it hung over the progress bar and pushed Copy Text a row
           down, out through the bottom of the card. */
        const rsPanel = loaderContainer.closest('.humanResult');
        if (rsPanel) {
            delete rsPanel.dataset.rsExpanded;
            rsPanel.querySelector('.quillOutput')?.classList.remove('rs-clamp');
            const rsMoreRun = rsPanel.querySelector('.rs-more');
            if (rsMoreRun) rsMoreRun.hidden = true;
        }
        /* first jump: the progress bar comes into view as the run starts -
           parked by its bottom edge on a first run, by its head on a re-run */
        scrollToResultPanel(rerunPanel, rerun);

        const loaderPercent = document.getElementById('loaderPercent');
        if (loaderPercent) loaderPercent.innerText = '0%';

        loadingText.innerText = phrases[0];
        phraseIndex = 0;

        // the loader is on screen by now, so the run starts from a rendered 0%
        startProgress(durationMs);
    }

    /* The grey stand-in for the result under the progress (designer's "Result
       without shift", Oct 2026): the version tabs, a few lines of text and
       the Check AI card for the humanizer, lines and a card for the other
       tools; the last block takes the room left. CSS shows it on stacked
       layouts only, while the tool is running. */
    function resultSkeleton(typeGeneration) {
        const stack = document.createElement('div');
        stack.className = 'sk-stack';
        stack.setAttribute('aria-hidden', 'true');
        const rows = typeGeneration === 'humanize'
            ? ['sk-tabs', 'sk-l', 'sk-l', 'sk-l', 'sk-l', 'sk-l s', 'sk-cta', 'sk-fill']
            // the checker and the paraphraser open a score card over the text
            : ['sk-score', 'sk-l', 'sk-l', 'sk-l', 'sk-l', 'sk-l', 'sk-l', 'sk-l s', 'sk-cta', 'sk-fill'];
        rows.forEach((row) => {
            const bar = document.createElement('div');
            bar.className = 'sk ' + row;
            stack.append(bar);
        });
        return stack;
    }

    /* Scroll anchoring is off for the frames the result lands in on a
       stacked layout (async.css keeps it off through the run): with it on,
       a result taller than the panel's reserve had Chrome move the page
       down by the growth on tablets, the panel's head off the top (tester,
       Oct 2026). The detector page keeps its anchor (its input column
       changes height on a re-check). */
    let anchoringTimer = 0;
    function suspendAnchoring() {
        if (!matchMedia('(max-width: 900px)').matches || document.body.classList.contains('ai-detector-page')) return;
        const root = document.documentElement;
        root.style.overflowAnchor = 'none';
        clearTimeout(anchoringTimer);
        anchoringTimer = setTimeout(() => { root.style.overflowAnchor = ''; }, 1500);
    }

    function hideLoader() {
        clearInterval(interval);
        stopProgress();
        suspendAnchoring();
        loaderContainer.closest('.tool')?.classList.remove('is-running');
        loaderContainer.parentElement?.querySelector(':scope > .sk-stack')?.remove();
        loaderContainer.style.display = 'none';
        return;
        loadingText.innerText = __('content.loader_done');

        setTimeout(() => {
            loaderContainer.style.display = 'none';
        }, 800);
    }

    // end loader
    let lastHeight = 0;

    window.addEventListener('resize', function() {
        lastHeight = 0;
    });

    function adjustEditorHeight(idx) {
        // Auto-height is frozen: pane size is controlled by CSS (min-height +
        // the manual resize handle). Only drop inline heights older code set.
        // It took a text length it never read, and every caller walked the
        // whole editor to hand it over — one of them on every keystroke.
        const quill = quillInstances[idx];
        if (!quill) return;

        const wrapper = quill.root.closest('.quill-editor-container');
        if (!wrapper) return;

        wrapper.style.height = '';
        const outputEl = quill.root.closest('.fields')?.querySelector('.quillOutput');
        if (outputEl) {
            outputEl.style.height = '';
            outputEl.style.minHeight = '';
        }
    }

    function changeVisibleStylesCount() {

        const screenWidth = window.innerWidth;

        let newVisibleCount;

        if (screenWidth < 768) {
            newVisibleCount = 1;
        } else if (screenWidth < 1200) {
            newVisibleCount = 4;
        } else {
            newVisibleCount = 6;
        }

        if (VISIBLE_COUNT !== newVisibleCount) {
            VISIBLE_COUNT = newVisibleCount;
            renderToolbar();
        }
    }

    function adjustResultBlockHeight(id) {

        const screenWidth = window.innerWidth;
        const resultField = document.getElementById(id);

        if (screenWidth < 992) {
            resultField.style.height = '';
            return;
        }

        const scrollHeight = resultField.scrollHeight + 32;
        const maxHeight = window.innerHeight - 500;

        const newHeight = Math.min(scrollHeight, maxHeight);
        const newOutputHeight = newHeight < 307 ? 307 : newHeight
        if(lastHeight < newHeight) {
            resultField.style.height = `${newOutputHeight}px`;
            lastHeight = newHeight;
        }

        return;
    }

    function makeError(selector, quill, isReturn = true) {
        let infoElements;
        let wrapper = document;

        if(quill !== null) {
            wrapper = quill.root.closest('.form-floating');
        }

        if (typeof selector === "string" && selector.startsWith('.')) {
            infoElements = wrapper?.querySelectorAll(selector);
        } else {
            const el = document.getElementById(selector);
            infoElements = el ? [el] : [];
        }

        const submitBtn = document.querySelectorAll('.submitQuill');
        const countWords = wrapper?.querySelector('.quillWordCount');

        submitBtn.forEach(el => el.setAttribute('disabled', 'disabled'));

        if (countWords) countWords.classList.add('danger');
        infoElements.forEach(el => {
            if (el.classList.contains('textMinLengthBlock') && !el.innerHTML.trim()) {
                el.innerHTML = __('content.error_min');
            }
            /* The cap warning ships empty with its wording in data-message, the
               same way the shared dialog does: the page used to state "this
               request exceeds the available processing capacity for today"
               before anything had been requested, hidden behind opacity and
               visibility rather than removed — text a crawler still reads. */
            if (el.dataset.message && !el.textContent.trim()) {
                el.textContent = el.dataset.message;
            }
        });
        infoElements.forEach(el => el.classList.add('active'));

        if(isReturn) {
            setTimeout(() => {
                submitBtn.forEach(el => el.removeAttribute('disabled'));
                const text = quill?.getText().trim() || '';
                const wordCount = getSmartWordCount(text);
                if (wordCount <= REQUEST_WORD_LIMIT) {
                    countWords.classList.remove('danger');
                }

                infoElements.forEach(el => el.classList.remove('active'));
            }, 2000);
        }
    }

    function guestPopupStorageKey(popupId) {
        return `popup_seen_${popupId}`;
    }

    function hasGuestSeenPopup(popupId) {
        if (!popupId) return false;
        try {
            return localStorage.getItem(guestPopupStorageKey(popupId)) === '1';
        } catch (e) {
            return false;
        }
    }

    function markGuestPopupSeen(popupId) {
        if (!popupId) return;
        try {
            localStorage.setItem(guestPopupStorageKey(popupId), '1');
        } catch (e) {}
    }

    function showUpdateModal(id) {
        const modal = document.getElementById(id);
        if (!modal) return false;

        const popupId = modal.getAttribute('data-popup-id'); // 'update-2025-10'
        if (!isLoggedIn && popupId && hasGuestSeenPopup(popupId)) {
            return false;
        }

        modal.classList.add('modal-open');
        document.body.classList.add('modal-open');

        const closeElements = modal.querySelectorAll('[data-bs-dismiss], [data-popup-dismiss], .modal-close, .greenBtn');
        const modalOverlay = modal.querySelector('.modal-overlay');

        const closeHandler = async () => {
            modal.classList.remove('modal-open');
            document.body.classList.remove('modal-open');

            if (!popupId) return;

            if (isLoggedIn && window.markPopupSeen) {
                try { await window.markPopupSeen(popupId); } catch(e) {}
            } else if (!isLoggedIn) {
                markGuestPopupSeen(popupId);
            }
        };

        [modalOverlay, ...closeElements].forEach(function (el) {
            if (!el) return;
            el.addEventListener('click', (e) => {
                const isBackdrop = el.classList.contains('modal-overlay');
                const isCloseX   = el.classList.contains('modal-close');
                const isGreen    = el.classList.contains('greenBtn');
                const isDismiss  = el.hasAttribute('data-popup-dismiss') || el.hasAttribute('data-bs-dismiss');

                if (isBackdrop || isCloseX || isGreen || isDismiss) {
                    closeHandler();
                }

            }, { once: true });
        });

        return true;
    }

    function tryShowUpgradeBannerModal() {
        if (!window.SHOW_UPGRADE_BANNER_MODAL) return false;
        return showUpdateModal('updateStyleModal');
    }

    /* No more auto-show on load: the release overlay now waits behind the
       What's new bell (whats-new.js). SHOW_UPGRADE_BANNER_MODAL only remains
       as the switch for the limit-triggered fallback above. */

    // === COOKIES UTILS ===
    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + (days*24*60*60*1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

    /* __() answers with the key itself when the page did not ship that string,
       and during a deploy a page rendered by the old code can end up running
       this file — same filename, new contents, old ?v= in the browser's cache.
       Rather than putting "content.modal_signed_out_title" in front of anyone,
       fall back to the English the key was written for. */
    function t(key, fallback) {
        const value = __(key);
        return value === key ? fallback : value;
    }

    function showLimitModal(title, message, actionText = null, loginCta = null) {
        const modal = document.getElementById('limitModal');
        if (!modal) return;

        const titleEl = document.getElementById('limitModalTitle');
        const bodyEl = document.getElementById('limitModalBody');

        if (titleEl) titleEl.textContent = title;
        if (bodyEl) bodyEl.innerHTML = window.SafeTextHtml.sanitize(message);
        // Only the explicit session-expired UI below supplies this action.
        // Provider HTML never decides a link URL or its attributes.
        if (bodyEl && loginCta) {
            const signInLink = document.createElement('a');
            signInLink.href = window.cleverLoginUrl || '/login';
            signInLink.target = '_blank';
            signInLink.rel = 'noopener';
            signInLink.textContent = loginCta.label;
            const suffix = document.createElement('span');
            suffix.innerHTML = window.SafeTextHtml.sanitize(loginCta.suffix);
            bodyEl.append(signInLink, suffix);
        }

        modal.classList.add('modal-open');
        document.body.classList.add('modal-open');

        const closeBtn = modal.querySelector('[data-bs-dismiss]');
        if (closeBtn) {
            if (actionText) closeBtn.textContent = actionText;
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }, { once: true });
        }
    }

    /* Signed in when the page loaded, signed out by the time it asked for
       something. csrf.js refuses to repeat that request with the fresh token,
       because the fresh token belongs to a guest session: the run would go
       through on the guest allowance and never reach the account's history,
       and nobody would be any the wiser. So say it plainly instead, and leave
       the text where it is — signing in again is one click, and the run is one
       more. */
    document.addEventListener('csrf:session-expired', function () {
        // already on screen from the press before this one
        if (document.getElementById('limitModal')?.classList.contains('modal-open')) return;
        hideLoader();
        document.querySelectorAll('.submitQuill').forEach(el => el.removeAttribute('disabled'));
        const description = t('content.modal_signed_out_descr', 'Your session ended while this page was open, so nothing was saved to your account. Your text is still here — <a href="/login" target="_blank" rel="noopener">sign in again</a> and try once more.');
        // Split this app-owned translation only, then reconstruct its action
        // with DOM APIs while all surrounding prose still passes the sanitizer.
        const action = description.match(/^([\s\S]*?)<a\b[^>]*>([^<]*)<\/a>([\s\S]*)$/i);
        showLimitModal(
            t('content.modal_signed_out_title', 'You have been signed out'),
            action ? action[1] : description + ' ',
            null,
            { label: action ? action[2] : 'Sign in again', suffix: action ? action[3] : '' }
        );
    });

    function isUnsupportedLanguageResponse(result) {
        return !!(result?.unsupported_language || result?.data?.unsupported_language);
    }

    function isAcademicUnsupportedLanguageResponse(result) {
        return result?.error_code === 'academic_style_unsupported_language';
    }

    // partial/unsupported-language-modal: the same dialog, with its subscribe
    // form, on every tool. It records the language the service found in the
    // text and the tool, as the subscription's needed language.
    const UNSUPPORTED_LANGUAGE_TOOLS = {
        humanize: 'humanizer',
        paraphraser: 'paraphraser',
        grammar: 'grammar',
        generation: 'writer'
    };

    /* When the dialog closes, the focus goes back to the tool's text: its
       editor, or for the writer (which has none) the title, its first field. */
    function showUnsupportedLanguageModal(result, typeGeneration, quill) {
        window.openUnsupportedLanguageModal?.({
            language: result?.data?.detected_lang,
            tool: UNSUPPORTED_LANGUAGE_TOOLS[typeGeneration] || 'humanizer',
            returnFocus: quill?.root
                || (typeGeneration === 'generation' ? document.getElementById('GenerationTitle') : null)
        });
    }

    function showAcademicUnsupportedLanguageModal() {
        showLimitModal(
            __('content.modal_academic_unsupported_language_title'),
            __('content.modal_academic_unsupported_language_descr'),
            __('content.modal_academic_unsupported_language_action')
        );
    }

    const inputAIStarter = document.getElementById('AIStarter');
    const resultAIStarter = document.getElementById('finalResult');

    inputAIStarter?.addEventListener('input', function () {
        const textLength = this.value.length;
        resultAIStarter.textContent = textLength + ' characters';
    });

    // Home-grown plain-text editor that replaced Quill. A contenteditable div
    // exposing the small API slice the rest of this file relies on (root,
    // getText/setText, enable/disable, focus, 'text-change'). Content is kept
    // as plain <p> lines; paste and drop are forced to text/plain. The ql-*
    // classes are kept so the existing CSS keeps applying.
    // One line per block. innerText cannot be used here: it counts the CSS
    // margins between paragraphs as extra line breaks, so an empty paragraph
    // came back as several blank lines — copy the text, paste it back and the
    // gaps kept growing.
    function readEditorText(root) {
        var blocks = Array.from(root.children).filter(el => el.nodeType === 1);
        if (!blocks.length) return root.textContent.replace(/ /g, ' ');

        return blocks
            .map(block => block.innerHTML === '<br>' ? '' : block.textContent.replace(/ /g, ' '))
            .join('\n');
    }

    // Pasted text may still carry inflated gaps (from an older copy of our own
    // editor, or from a document): keep at most one blank line between blocks.
    /* A pasted wall of text is cut like an uploaded one. Letting 10,000 words in
       and refusing them at submit wastes the paste; the limit is the same one
       the page prints beside its counter. Typing past the limit is left alone —
       only a paste or a drop is trimmed, and only after the text has landed, so
       what is measured is what the editor actually holds. */
    function enforcePastedLimit(root) {
        setTimeout(() => {
            const type = root.closest('[data-editor-type]')?.dataset.editorType;
            const editor = type ? getQuillForType(type) : null;
            const limit = paneWordLimit(root.closest('.fields'));
            if (!editor || !limit) return;
            const text = editor.getText().trim();
            if (getSmartWordCount(text) <= limit) return;
            editor.setText(truncateToWords(text, limit));
            showLimitModal(
                __('content.document_trimmed_title').replace(/:limit/g, formatCount(limit)),
                __('content.text_trimmed').replace(/:limit/g, formatCount(limit))
            );
        }, 0);
    }

    const MIN_WORDS_BY_MODE = {
        humanize: Math.max(1, Number(window.APP_LIMITS?.humanizerMinWords ?? 30)),
        grammar: Math.max(1, Number(window.APP_LIMITS?.grammarMinWords ?? 10)),
        paraphraser: Math.max(1, Number(window.APP_LIMITS?.paraphraserMinWords ?? 10)),
    };

    function minimumWordsForMode(type) {
        return MIN_WORDS_BY_MODE[type] ?? MIN_WORDS_BY_MODE.humanize;
    }

    /* How long the text-change handlers wait behind a keystroke. Long enough
       that a burst of typing settles into one pass, short enough that the
       counter still reads as live. */
    const TEXT_CHANGE_DELAY = 120;

    function normalizePastedText(text) {
        return String(text ?? '')
            .replace(/\r\n?/g, '\n')
            .replace(/\n{3,}/g, '\n\n');
    }

    function createPlainEditor(container) {
        if (!container) return null;

        container.classList.add('ql-container', 'ql-snow');

        const root = document.createElement('div');
        root.className = 'ql-editor';
        root.setAttribute('contenteditable', 'true');
        root.innerHTML = '<p><br></p>';
        container.appendChild(root);

        const changeHandlers = [];
        const typingHandlers = [];
        let changeTimer = null;

        const editor = {
            root,
            on(event, handler) {
                if (event === 'text-change') changeHandlers.push(handler);
                /* Runs on the keystroke itself, so it must not read the text:
                   toggles only, off what the editor already knows. */
                if (event === 'typing') typingHandlers.push(handler);
            },
            emitChange() {
                clearTimeout(changeTimer);
                changeTimer = null;
                typingHandlers.forEach(handler => handler());
                changeHandlers.forEach(handler => handler());
            },
            /* Typing pays for the keystroke and nothing else. The handlers that
               read the whole text — the word count and the limit checks — run
               once the browser has painted the character, and coalesce while
               the keys keep coming. A caller that replaces the field outright
               still uses emitChange() and gets everything at once. */
            emitTyping() {
                typingHandlers.forEach(handler => handler());
                if (changeTimer === null) {
                    changeTimer = setTimeout(() => {
                        changeTimer = null;
                        changeHandlers.forEach(handler => handler());
                    }, TEXT_CHANGE_DELAY);
                }
            },
            /* The empty state is the single <p><br></p> the editor keeps, so
               more than one block is text by definition and the long read never
               happens on a full field. */
            isEmpty() {
                return root.childElementCount <= 1 && root.textContent.trim() === '';
            },
            getText() {
                return readEditorText(root);
            },
            setText(text) {
                const lines = String(text ?? '').replace(/\r\n/g, '\n').split('\n');
                root.innerHTML = lines
                    .map(line => '<p>' + (line.trim() === '' ? '<br>' : escapeHtml(line)) + '</p>')
                    .join('') || '<p><br></p>';
                this.emitChange();
            },
            // Rich sources (samples, uploaded documents) enter as plain text.
            setHTML(html) {
                this.setText(htmlToPlainText(html));
            },
            clear() {
                this.setText('');
            },
            enable(enabled = true) {
                root.setAttribute('contenteditable', enabled ? 'true' : 'false');
                container.classList.toggle('ql-disabled', !enabled);
            },
            disable() {
                this.enable(false);
            },
            focus() {
                root.focus();
            },
        };

        // "Empty" must stay one empty paragraph — the rest of the code (and
        // the submit payload) relies on the <p><br></p> shape Quill used.
        const ensureNotHollow = () => {
            if (root.textContent === '' && !root.querySelector('p')) {
                root.innerHTML = '<p><br></p>';
                const range = document.createRange();
                range.setStart(root.firstChild, 0);
                range.collapse(true);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
        };

        root.addEventListener('input', () => {
            ensureNotHollow();
            editor.emitTyping();
        });

        // No formatting: block the browser's rich-text shortcuts (Cmd/Ctrl+B…).
        root.addEventListener('beforeinput', (e) => {
            if (e.inputType && e.inputType.indexOf('format') === 0) e.preventDefault();
        });

        root.addEventListener('paste', (e) => {
            e.preventDefault();
            const text = normalizePastedText(e.clipboardData?.getData('text/plain') || '');
            if (text) document.execCommand('insertText', false, text);
            enforcePastedLimit(root);
        });

        root.addEventListener('drop', (e) => {
            // File drops belong to the paraphraser dropzone.
            if (e.dataTransfer?.types.includes('Files')) return;
            e.preventDefault();
            const text = normalizePastedText(e.dataTransfer?.getData('text/plain') || '');
            if (text) {
                root.focus();
                document.execCommand('insertText', false, text);
                enforcePastedLimit(root);
            }
        });

        setupEditorHandlers(editor, container);

        return editor;
    }

    /* Each tool remembers its own text, the way the detector already did:
       leave the page, come back, and what you typed is where you left it. Per
       tool and not shared — the humanizer's draft is not the paraphraser's, and
       one tool's result is not another's input; the only text that travels
       between them is the detector's explicit "Humanize this text" handoff.
       sessionStorage, so it lives as long as the tab and no longer.
       Written on a delay and flushed on the way out, for the same reason the
       word counter is: this stores the whole text, and doing that on every
       keystroke is exactly what made typing expensive. */
    const DRAFT_PREFIX = 'chz-draft:';
    const DRAFT_DELAY = 600;

    function draftKey(editor) {
        const type = editor.root.closest('[data-editor-type]')?.dataset.editorType;
        return type ? DRAFT_PREFIX + type : null;
    }

    function writeDraft(editor, text) {
        const key = draftKey(editor);
        if (!key) return;
        try {
            if (text) sessionStorage.setItem(key, text);
            else sessionStorage.removeItem(key);
        } catch (error) {}
    }

    function restoreDraft(editor) {
        const key = draftKey(editor);
        if (!key) return;
        try {
            const text = sessionStorage.getItem(key);
            // never over the top of something already in the field
            if (text && !editor.getText().trim()) editor.setText(text);
        } catch (error) {}
    }

    function setupEditorHandlers(editor, container) {

        const wrapper = container.closest('.form-floating');
        const customPlaceholder = wrapper.querySelector('.custom-placeholder');
        const removeText = wrapper.querySelector('.remove-text');
        const countWords = wrapper.querySelector('.quillWordCount');
        const originalWordsNum = wrapper.querySelector('.originalWordsNum');
        const errorEl = document.getElementById('uploadError');

        // The placeholder (with the quick actions) stays visible while the
        // editor is empty — it hides only once content appears (text-change).
        editor.root.addEventListener('focus', () => {
            errorEl?.classList.add('hidden');
        });

        const initialSubmit = wrapper.closest('.fields')?.querySelector('.submitQuill');
        if (initialSubmit && !editor.getText().trim()) initialSubmit.disabled = true;

        let draftTimer = null;
        // a draft is only worth keeping if it survives the page going away
        const flushDraft = () => {
            clearTimeout(draftTimer);
            writeDraft(editor, editor.getText().trim());
        };
        editor.root.addEventListener('blur', flushDraft);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') flushDraft();
        });
        window.addEventListener('pagehide', flushDraft);

        /* What the typist has to see on the keystroke: the placeholder out of
           the way, the clear pill lit, the button live. None of it needs the
           text — only whether there is any — so none of it reads the field.
           This used to sit at the top of the handler below, behind
           editor.root.innerHTML: serialising the whole editor to compare it
           with '<p><br></p>', on every key, to answer a yes-or-no question. */
        editor.on('typing', function () {
            const isEmpty = editor.isEmpty();

            customPlaceholder?.classList.toggle('hidden', !isEmpty);
            removeText?.classList.toggle('active', !isEmpty);
            if (!isEmpty) errorEl?.classList.add('hidden');

            const paneSubmit = wrapper.closest('.fields')?.querySelector('.submitQuill');
            if (paneSubmit && !paneSubmit.dataset.busy) paneSubmit.disabled = isEmpty;
        });

        editor.on('text-change', function() {
            const text = editor.getText().trim();
            const wordCount = getSmartWordCount(text);

            /* Two ways to be over: more words than one request takes, or more
               than the day has left. Both say it the same way — the counter
               goes amber — and both are answered on submit by the shared
               dialog, which is what the paraphraser and the checker already
               did. One decision, so neither can undo the other's colour. */
            const overRequest = wordCount > REQUEST_WORD_LIMIT;
            const overDaily = isLoggedIn && wordCount > wordsRest;
            countWords.classList.toggle('danger', overRequest || overDaily);

            // the result pane's placeholder comes back once under the request cap
            const resultPlace = wrapper.closest('.fields')?.querySelector('.quillOutput .place');
            if (!overRequest && resultPlace && resultPlace.dataset.defaultText) {
                resultPlace.innerHTML = resultPlace.dataset.defaultText;
                delete resultPlace.dataset.defaultText;
            }

            originalWordsNum.innerText = formatCount(wordCount);

            // No text, no run — the paraphraser and the checker already work this
            // way, and an enabled button over an empty field promises nothing.
            const paneSubmit = wrapper.closest('.fields')?.querySelector('.submitQuill');
            if (paneSubmit && !paneSubmit.dataset.busy) paneSubmit.disabled = !text;

            clearTimeout(draftTimer);
            draftTimer = setTimeout(() => writeDraft(editor, text), DRAFT_DELAY);

        });

        removeText?.addEventListener('click', function() {
            editor.clear();
            clearTimeout(draftTimer);
            writeDraft(editor, '');
            // clearing the text hides the result panel again on mobile
            wrapper.closest('.tool')?.classList.remove('has-run', 'has-result');
            // and resets the result pane to its empty state
            clearResultPane(wrapper);
        });

        customPlaceholder?.addEventListener('click', (e) => {
            // Clicks on the placeholder's own controls (try-sample, paste,
            // upload) must not steal focus into the editor — focusing hides
            // the placeholder, so the buttons would jump away and back.
            if (e.target.closest('a, button, input, label')) return;
            editor.focus();
        });
    }

    // Remember each result pane's empty-state placeholder so "Remove text"
    // can put it back after a run replaced it with the result.
    document.querySelectorAll('.quillOutput').forEach(el => {
        const place = el.querySelector('.place');
        if (place) el.dataset.placeDefault = place.innerHTML;
    });

    // "Remove text" clears the input — the result pane resets with it:
    // placeholder back, counter to zero, variant tabs / note / toggle hidden.
    function clearResultPane(wrapper) {
        const fields = wrapper.closest('.fields');
        if (!fields) return;
        const output = fields.querySelector('.quillOutput');
        if (output) {
            output.classList.remove('no-hl', 'rs-clamp');
            output.innerHTML = '<p class="place">' + (output.dataset.placeDefault || __('content.new_text')) + '</p>';
            updateCopyButtonVisibility(output);
        }
        const rsMore = fields.querySelector('.rs-more');
        if (rsMore) rsMore.hidden = true;
        const resultWordsNum = fields.querySelector('.resultWordsNum');
        if (resultWordsNum) resultWordsNum.innerText = '0';
        const resultNote = fields.querySelector('.result-note');
        if (resultNote) resultNote.hidden = true;
        const variantBar = fields.querySelector('.variant-bar');
        if (variantBar) { variantBar.innerHTML = ''; variantBar.classList.remove('show'); }
        const hlControls = fields.querySelector('.hl-controls');
        if (hlControls) hlControls.classList.remove('show', 'visible');
        const diffChip = fields.querySelector('.diff-chip');
        if (diffChip) diffChip.hidden = true;
        window.dispatchEvent(new CustomEvent('upsell:cleared'));
    }

    const allQuillEditors = Array.from(document.querySelectorAll('.quill-editor-container'));
    const quillInstances = allQuillEditors.map(container => createPlainEditor(container));
    quillInstances.forEach(restoreDraft);

    quillInstances.forEach((quill, idx) => {
        quill.on('text-change', () => adjustEditorHeight(idx));
    });

    // The panes differ in chrome height before the first run — level them on
    // load too. Deferred to window load: style-bottom.css arrives async
    // (media="print" swap), and measuring before it lands bakes an unstyled
    // editor height in.
    const levelHumanizePanes = () => {
        quillInstances.forEach((quill, idx) => {
            const container = allQuillEditors[idx];
            const type = container?.dataset.editorType;
            // Paraphraser still carries its style toolbar row and stays level
            // statically. Hidden panes (inactive tabs) can't be measured —
            // they get leveled when their tab is shown (showForm).
            if ((type === 'humanize' || type === 'grammar') && container.offsetParent !== null) {
                adjustEditorHeight(idx);
            }
        });
    };
    if (document.readyState === 'complete') {
        requestAnimationFrame(levelHumanizePanes);
    } else {
        window.addEventListener('load', () => requestAnimationFrame(levelHumanizePanes));
    }

    let levelResizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(levelResizeTimer);
        levelResizeTimer = setTimeout(levelHumanizePanes, 150);
    });

    // PARAPHRASE STYLES

    // First six are the ones the sample shows before "All": Standard, Fluency,
    // Formal, Simple, Academic, Creative. The rest keep their previous order.
    // Labels resolve through the page's __() map when it carries a
    // content.par_style_* key, so localized pages show localized tabs.
    const styleLabel = (id, fallback) => {
        if (typeof __ !== 'function') return fallback;
        const key = 'content.par_style_' + id;
        const value = __(key);
        return value === key ? fallback : value;
    };
    const STYLES = [
        ['standard', 'Standard'], ['fluency', 'Fluency'], ['formal', 'Formal'],
        ['simple', 'Simple'], ['academic', 'Academic'], ['creative', 'Creative'],
        ['humanize', 'Humanize'], ['casual', 'Casual'], ['professional', 'Professional'],
        ['shorten', 'Shorten'], ['expand', 'Expand'], ['engaging', 'Engaging'],
        ['persuasive', 'Persuasive'], ['friendly', 'Friendly'], ['confident', 'Confident'],
        ['vivid', 'Vivid'], ['high_school', 'High School'], ['middle_school', 'Middle School'],
        ['empathetic', 'Empathetic'], ['diplomatic', 'Diplomatic'], ['lawyer', 'Lawyer'],
        ['engineer', 'Engineer'], ['doctor', 'Doctor'],
    ].map(([id, fallback]) => ({ id, label: styleLabel(id, fallback) }));

    let VISIBLE_COUNT = 6;
    let styles = [...STYLES];
    let selectedStyle = 'standard';
    let mainVisibleStyle = styles[0].id;

    const tabsEl = document.getElementById('styleTabs');
    const hiddenInput = document.getElementById('paraphraseStyle');

    function renderToolbar() {
        if (!tabsEl) return;

        tabsEl.innerHTML = '';

        const mainStyle = styles.find(s => s.id === mainVisibleStyle);
        let rest = styles.filter(s => s.id !== mainVisibleStyle);
        let visible = [mainStyle, ...rest.slice(0, VISIBLE_COUNT - 1)];

        visible.forEach(style => {
            const btn = document.createElement('button');
            let isActive = style.id === selectedStyle;
            btn.className = 'style-tab' + (isActive ? ' active' : '');
            btn.textContent = style.label;
            btn.type = 'button';

            if (style.id === mainVisibleStyle) {
                btn.onclick = () => selectStyle(style.id, false, false);
            } else {
                btn.onclick = () => selectStyle(style.id, false, false);
            }

            tabsEl.appendChild(btn);
        });

        tabsEl.appendChild(createDropdown(styles));
        /* the row renders a subset of the full list — remember the total so
           the dropdown sync knows pills are missing even when none of the
           rendered ones is hidden by a breakpoint */
        tabsEl.dataset.styleCount = styles.length;

        hiddenInput.value = selectedStyle;
        syncStyleDropdowns();
    }

    /* "All ▾" earns its place only while some styles are out of the row —
       rendered but hidden by a CSS breakpoint, or not rendered at all. A
       fixed media query broke every time a breakpoint or the list changed
       (at 840px a goal pill hid with no menu to reach it), so measure the
       row instead. Covers the goal pills and the style tabs alike, for any
       future number of styles. */
    function syncStyleDropdowns() {
        document.querySelectorAll('.tool-controls .style-tabs').forEach(tabs => {
            const dropdown = tabs.querySelector(':scope > .style-dropdown');
            if (!dropdown) return;
            const pills = [...tabs.querySelectorAll(':scope > button')];
            const fullCount = Number(tabs.dataset.styleCount) || pills.length;
            const everyPillShown = pills.length >= fullCount
                && pills.every(pill => getComputedStyle(pill).display !== 'none');
            dropdown.style.display = everyPillShown ? 'none' : '';
        });
    }

    let styleDropdownSyncTimer;
    window.addEventListener('resize', () => {
        clearTimeout(styleDropdownSyncTimer);
        styleDropdownSyncTimer = setTimeout(syncStyleDropdowns, 100);
    });
    syncStyleDropdowns();

    const toolbar = document.getElementById('customToolbar');

    document.addEventListener('click', (e) => {
        if (toolbar && toolbar.contains(e.target)) return;

        document.querySelectorAll('.style-dropdown.open')
            .forEach(dropdown => dropdown.classList.remove('open'));
    });

    function triggerHumanizer() {
        const switchItem = document.querySelector(
            '.switch-item[data-control="AIHumanizer"][data-form-type="humanize"]'
        );

        if (switchItem) {
            switchItem.click();
            return;
        }

        const link = document.querySelector('#humanizeTab');

        if (link) {
            window.location.href = link.href;
            return;
        }

        window.location.href = '/';
    }

    function createDropdown(items) {
        const wrapper = document.createElement('div');
        wrapper.className = 'style-dropdown';

        const trigger = document.createElement('button');
        trigger.className = 'style-tab';
        const allLabel = (typeof __ === 'function' && __('content.par_style_all') !== 'content.par_style_all')
            ? __('content.par_style_all') : 'All';
        trigger.innerHTML = allLabel + ' <span class="caret"></span>';
        trigger.type = 'button';

        const panel = document.createElement('div');
        panel.className = 'dropdown-panel';

        /* the grid and its column divider live on this wrapper, not on the
           scrolling panel — see .dropdown-cols in async.css */
        const cols = document.createElement('div');
        cols.className = 'dropdown-cols';
        panel.appendChild(cols);

        items.forEach(style => {
            const item = document.createElement('div');
            item.className = 'item' + (style.id === selectedStyle ? ' active' : '');
            item.textContent = style.label;

            item.onclick = () => {
                wrapper.classList.remove('open');
                selectStyle(style.id, true, true);
            };

            cols.appendChild(item);
        });

        trigger.onclick = (e) => {
            e.stopPropagation();
            wrapper.classList.toggle('open');
        };

        wrapper.append(trigger, panel);
        return wrapper;
    }

    function selectStyle(id, moveToTop = false, dropDownClick = false) {
        selectedStyle = id;

        if (id === 'humanize') {
            triggerHumanizer();
            return;
        }
        if (dropDownClick) {
            mainVisibleStyle = id;
        }

        renderToolbar();
    }

    renderToolbar();

    allQuillEditors.forEach((container, idx) => {
        container.closest('.form-floating').dataset.quillIndex = idx;
    });

    function cleanLeadingEmptyBlocksFromHTML(html) {
        let replaced = true;
        const patterns = [
            // <p><br></p><hX><br></hX>
            /^\s*(<(p|h[1-6])>\s*<br\s*\/?>\s*<\/\2>)/i,
            // <ul><li><br></li></ul><ol>...
            /^\s*<(ul|ol)>\s*<(li)>\s*<br\s*\/?>\s*<\/\2>\s*<\/\1>/i,
            // <li><br></li>
            /^\s*<li>\s*<br\s*\/?>\s*<\/li>/i,
            // <strong><br></strong>, <em><br></em>, <u><br></u>
            /^\s*<(strong|em|u)>\s*<br\s*\/?>\s*<\/\1>/i,
        ];
        while (replaced) {
            replaced = false;
            for (const pattern of patterns) {
                if (pattern.test(html)) {
                    html = html.replace(pattern, '');
                    replaced = true;
                }
            }
        }
        return html.trim();
    }

    function attrsToString(attrs) {
        if (!attrs || (Array.isArray(attrs) && attrs.length === 0)) return '';
        return ' ' + Object.entries(attrs)
            .map(([k, v]) => `${k}="${String(v).replace(/"/g, '&quot;')}"`)
            .join(' ');
    }

    function escapeRegex(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function wrapFoundInSentence(html, tags_obj) {
        if (!tags_obj || tags_obj.msg !== "ok") return html;
        const tags = tags_obj.results;

        tags.forEach(item => {
            if (!item.sentence || !item.found) return;
            const escapedSentence = escapeRegex(item.sentence);
            html = html.replace(new RegExp(escapedSentence), function(match) {
                const escFound = escapeRegex(item.found);
                const tagCheck = new RegExp(`<${item.tag}(\\s|>)`);
                if (tagCheck.test(match)) return match;
                return match.replace(new RegExp(escFound), `<${item.tag}${attrsToString(item.attrs)}>${item.found}</${item.tag}>`);
            });
        });
        return html;
    }

    function mergeSiblingLists(root) {
        const lists = Array.from(root.querySelectorAll('ul, ol'));

        lists.forEach(list => {
            let next = list.nextSibling;
            while (next && next.nodeType === Node.TEXT_NODE && !next.textContent.trim()) {
                next = next.nextSibling;
            }

            if (!next || next.tagName !== list.tagName) return;

            const nextLis = Array.from(next.children).filter(n => n.tagName === 'LI');
            nextLis.forEach(li => list.appendChild(li));
            next.remove();
        });
    }

    function attachIndentedLists(root) {
        const lists = Array.from(root.querySelectorAll('ul, ol'));

        const getIndent = (list) => {
            const firstLi = list.querySelector('li');
            if (!firstLi) return 0;

            const indentClass = [...firstLi.classList]
                .find(c => c.startsWith('ql-indent-'));

            return indentClass
                ? parseInt(indentClass.replace('ql-indent-', ''), 10)
                : 0;
        };

        const indents = lists.map(getIndent);

        lists.forEach((list, index) => {
            if (!list || !list.parentNode) return;

            const indent = indents[index];

            if (indent > 0) {
                for (let j = index - 1; j >= 0; j--) {
                    const prevList = lists[j];
                    if (!prevList || !prevList.parentNode) continue;

                    const prevIndent = indents[j];

                    if (prevIndent < indent) break;

                    if (prevIndent === indent && prevList.tagName === list.tagName) {
                        const lis = Array.from(list.children).filter(n => n.tagName === 'LI');
                        lis.forEach(li => prevList.appendChild(li));

                        list.remove();
                        lists[index] = null;
                        return;
                    }
                }
            }

            if (indent === 0) return;

            let parentIndex = -1;
            for (let j = index - 1; j >= 0; j--) {
                const prevList = lists[j];
                if (!prevList || !prevList.parentNode) continue;

                const prevIndent = indents[j];
                if (prevIndent < indent) {
                    parentIndex = j;
                    break;
                }
            }

            if (parentIndex === -1) return;

            const parentList = lists[parentIndex];
            const lastLi = parentList.querySelector('li:last-child');
            if (!lastLi) return;

            let lastLiIndent = 0;
            const lastLiIndentClass = [...lastLi.classList]
                .find(c => c.startsWith('ql-indent-'));
            if (lastLiIndentClass) {
                lastLiIndent = parseInt(lastLiIndentClass.replace('ql-indent-', ''), 10);
            }

            if (indent === lastLiIndent && parentList.tagName === list.tagName) {
                const lis = Array.from(list.children).filter(n => n.tagName === 'LI');
                lis.forEach(li => parentList.appendChild(li));

                list.remove();
                lists[index] = null;
                return;
            }

            lastLi.appendChild(list);
        });
    }

    function normalizeQuillLists(root) {
        attachIndentedLists(root);

        const lists = root.querySelectorAll('ul, ol');

        lists.forEach(list => {
            const items = Array.from(list.children).filter(n => n.tagName === 'LI');
            if (!items.length) return;

            const newRoot = document.createElement(list.tagName.toLowerCase());

            const firstIndentClass = [...items[0].classList]
                .find(c => c.startsWith('ql-indent-'));

            const baseIndent = firstIndentClass
                ? parseInt(firstIndentClass.replace('ql-indent-', ''), 10)
                : 0;

            let stack = [{ indent: 0, list: newRoot }];
            let prevLi = null;

            items.forEach(li => {
                const indentClass = [...li.classList]
                    .find(c => c.startsWith('ql-indent-'));

                const rawIndent = indentClass
                    ? parseInt(indentClass.replace('ql-indent-', ''), 10)
                    : 0;

                const indent = Math.max(0, rawIndent - baseIndent);

                if (indentClass) li.classList.remove(indentClass);

                while (stack.length > indent + 1) {
                    stack.pop();
                }

                if (indent + 1 > stack.length) {
                    if (!prevLi) return;

                    const subList = document.createElement(list.tagName.toLowerCase());
                    prevLi.appendChild(subList);
                    stack.push({ indent, list: subList });
                }

                stack[stack.length - 1].list.appendChild(li);
                prevLi = li;
            });

            list.replaceWith(newRoot);
        });

        mergeSiblingLists(root);
    }


    function escapeHtml(s) {
        const div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
    }

    // Token = word OR whitespace run OR a single punctuation char.
    const PLAIN_TOKEN_RE = /[\p{L}\p{N}_]+|\s+|[^\p{L}\p{N}_\s]/gu;
    function tokenizePlain(text) {
        return text.match(PLAIN_TOKEN_RE) || [];
    }

    // Word-level diff — port of difflib.SequenceMatcher (with junk, see below).
    // Returns opcodes: [tag, i1, i2, j1, j2], tag in equal|replace|delete|insert.
    function diffOpcodes(a, b) {
        const b2j = new Map();
        for (let i = 0; i < b.length; i++) {
            const arr = b2j.get(b[i]);
            if (arr) arr.push(i);
            else b2j.set(b[i], [i]);
        }

        // Every second token of prose is a space, so the inner loop below used
        // to visit every space of `b` for every space of `a` — a 3,000-word
        // text took ~30s PER VARIANT SWITCH and pinned a core. Popular tokens
        // (whitespace, "the", commas) may CONTINUE a chain but never START one:
        // that skips the quadratic space-x-space work while producing the same
        // matches, because no meaningful match anchors on a space alone.
        const popularThreshold = Math.max(8, 1 + Math.floor(b.length / 50));
        const popularTokens = new Set();
        for (const [tok, js] of b2j) {
            if (/^\s/.test(tok) || js.length >= popularThreshold) popularTokens.add(tok);
        }

        function findLongestMatch(alo, ahi, blo, bhi) {
            let besti = alo, bestj = blo, bestsize = 0;
            let j2len = new Map();
            for (let i = alo; i < ahi; i++) {
                const js = b2j.get(a[i]);
                // Most tokens of `a` never occur in `b` (or are junk): the chain
                // map only needs resetting, not reallocating, on those.
                if (!js) {
                    if (j2len.size) j2len = new Map();
                    continue;
                }
                const newj2len = new Map();
                if (popularTokens.has(a[i])) {
                    for (const [jprev, k] of j2len) {
                        const j = jprev + 1;
                        if (j >= blo && j < bhi && b[j] === a[i]) {
                            const nk = k + 1;
                            newj2len.set(j, nk);
                            if (nk > bestsize) { besti = i - nk + 1; bestj = j - nk + 1; bestsize = nk; }
                        }
                    }
                } else {
                    for (const j of js) {
                        if (j < blo) continue;
                        if (j >= bhi) break;
                        const k = (j2len.get(j - 1) || 0) + 1;
                        newj2len.set(j, k);
                        if (k > bestsize) { besti = i - k + 1; bestj = j - k + 1; bestsize = k; }
                    }
                }
                j2len = newj2len;
            }
            while (besti > alo && bestj > blo && a[besti - 1] === b[bestj - 1]) {
                besti--; bestj--; bestsize++;
            }
            while (besti + bestsize < ahi && bestj + bestsize < bhi &&
                   a[besti + bestsize] === b[bestj + bestsize]) {
                bestsize++;
            }
            return [besti, bestj, bestsize];
        }

        const la = a.length, lb = b.length;
        const queue = [[0, la, 0, lb]];
        const blocks = [];
        while (queue.length) {
            const [alo, ahi, blo, bhi] = queue.pop();
            const [i, j, k] = findLongestMatch(alo, ahi, blo, bhi);
            if (k) {
                blocks.push([i, j, k]);
                if (alo < i && blo < j) queue.push([alo, i, blo, j]);
                if (i + k < ahi && j + k < bhi) queue.push([i + k, ahi, j + k, bhi]);
            }
        }
        blocks.sort((x, y) => x[0] - y[0] || x[1] - y[1] || x[2] - y[2]);

        let i1 = 0, j1 = 0, k1 = 0;
        const merged = [];
        for (const [i2, j2, k2] of blocks) {
            if (i1 + k1 === i2 && j1 + k1 === j2) {
                k1 += k2;
            } else {
                if (k1) merged.push([i1, j1, k1]);
                i1 = i2; j1 = j2; k1 = k2;
            }
        }
        if (k1) merged.push([i1, j1, k1]);
        merged.push([la, lb, 0]);

        let i = 0, j = 0;
        const ops = [];
        for (const [ai, bj, size] of merged) {
            let tag = '';
            if (i < ai && j < bj) tag = 'replace';
            else if (i < ai) tag = 'delete';
            else if (j < bj) tag = 'insert';
            if (tag) ops.push([tag, i, ai, j, bj]);
            i = ai + size;
            j = bj + size;
            if (size) ops.push(['equal', ai, i, bj, j]);
        }
        return ops;
    }

    function detectorSupportsLanguage(resultLanguage, supportedLanguages) {
        const raw = String(resultLanguage ?? '').trim().toLowerCase().replace(/_/g, '-');
        if (!raw || supportedLanguages.length === 0) return false;

        const directCandidates = new Set([raw, raw.split('-', 1)[0]]);
        if (supportedLanguages.some(code => directCandidates.has(code))) return true;

        // Humanizer responses use English language names (such as "English"),
        // while the deployment setting uses stable ISO language codes.
        if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return false;

        try {
            const names = new Intl.DisplayNames(['en'], { type: 'language' });
            return supportedLanguages.some(code => {
                const baseCode = code.split('-', 1)[0];
                return [code, baseCode].some(candidate =>
                    String(names.of(candidate) ?? '').trim().toLowerCase() === raw
                );
            });
        } catch (_) {
            return false;
        }
    }

    function updateDetectorResultNote(resultNote, resultText, type, language) {
        if (!resultNote) return;

        const minWords = Math.max(1, Number(resultNote.dataset.detectorMinWords || 1));
        const supportedLanguages = String(resultNote.dataset.detectorLanguages || '')
            .split(/[,;]/)
            .map(code => code.trim().toLowerCase().replace(/_/g, '-'))
            .filter(Boolean);

        resultNote.hidden = type !== 'humanize'
            || getSmartWordCount(resultText) < minWords
            || !detectorSupportsLanguage(language, supportedLanguages);
    }

    function insertRewrittenTextWithStyling(originalHTML, rewrittenText, tags, quill, type='humanize', language=null) {
        originalHTML = window.SafeTextHtml.sanitize(originalHTML);
        originalHTML = cleanLeadingEmptyBlocksFromHTML(originalHTML);
        const trimmedOriginal = originalHTML.trim();
        const hasNoOriginal = !trimmedOriginal || trimmedOriginal === '' || trimmedOriginal === '<p><br></p>';
        if (hasNoOriginal && rewrittenText) {
            const paragraphs = rewrittenText.split(/\n\n+/).filter(Boolean);
            const html = paragraphs.length
                ? paragraphs.map(p => '<p>' + escapeHtml(p.replace(/\n/g, '<br>')) + '</p>').join('')
                : '<p>' + escapeHtml(rewrittenText.replace(/\n/g, '<br>')) + '</p>';
            const wrapper = quill.root.closest('.form-floating');
            const quillOutput = wrapper ? wrapper.parentNode.querySelector('.quillOutput') : document.getElementById('quillOutput');
            const resultWordsNum = wrapper ? wrapper.parentNode.querySelector('.resultWordsNum') : document.querySelector('.resultWordsNum');
            const resultNote = wrapper ? wrapper.parentNode.querySelector('.result-note') : null;
            if (quillOutput) {
                quillOutput.innerHTML = html;
                normalizeQuillLists(quillOutput);
                if (resultWordsNum) resultWordsNum.innerText = formatCount(getSmartWordCount(rewrittenText));
                updateDetectorResultNote(resultNote, rewrittenText, type, language);
                updateCopyButtonVisibility(quillOutput);
                // measured right away, so the text paints already clamped
                // (settleResultPanel)
                settleResultPanel(quillOutput);
                applyResultClamp(quillOutput, getSmartWordCount(rewrittenText));
            }
            document.querySelectorAll('.submitQuill').forEach(function(el) { el.removeAttribute('disabled'); });
            hideLoader();
            enableLeftEditor(quill);
            return;
        }

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = window.SafeTextHtml.sanitize(trimmedOriginal);

        const originalLines = [];
        let rewrittenLines = [];
        const styledLines = [];
        for (const node of tempDiv.childNodes) {
            if (node.nodeType === 1 || node.nodeType === 3) {
                const text = node.textContent.trim();
                //if (text.length > 0) {
                if (node.tagName === 'PRE') {
                    const preText = node.textContent || "";
                    const preLinesCount = preText.split('\n').length;
                    originalLines.push({
                        text: preText,
                        html: node.outerHTML || node.textContent,
                        isPre: true,
                        preLinesCount: preLinesCount
                    });
                } else if (['UL', 'OL'].includes(node.tagName)) {
                    const items = [];
                    for (const li of node.querySelectorAll('li')) {
                        items.push({
                            text: li.textContent.trim(),
                            html: li.outerHTML
                        });
                    }
                    originalLines.push({
                        isList: true,
                        listTag: node.tagName.toLowerCase(),
                        items
                    });
                } else {
                    originalLines.push({
                        text,
                        html: node.outerHTML || node.textContent
                    });
                }
                //}
            }
        }


        rewrittenLines = rewrittenText
            .split('\n')
            .map(line => line.trim())
        //.filter(Boolean);
        function normalize(text) {
            return text
                .replace(/[\u00A0]/g, ' ')                 // NBSP → space
                .toLowerCase()
                .replace(/[\u2018\u2019]/g, "'")
                .replace(/[\u2013\u2014–—\-]/g, ' ')
                .replace(/[.,?!:;"“”""‘’]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        }

        function extractLiClass(html) {
            const match = html.match(/<li[^>]*class="([^"]+)"/i);
            return match ? match[1] : '';
        }

        function applyInlineTags(originalHTML, rewrittenText) {
            function escapeRegExp(s) {
                return String(s).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            }

            function patternFromText(s) {
                const replacedDashes = s.replace(/[—–]/g, '-');
                const normalizedSpaces = replacedDashes.replace(/\u00A0/g, ' ');
                const parts = normalizedSpaces.trim().split(/\s+/).map(escapeRegExp);
                return parts.join('\\s+');
            }

            function isWordChar(ch) {
                if (!ch) return false;
                return /[\p{L}\p{N}'’]/u.test(ch);
            }
            const dummy = document.createElement('div');
            dummy.innerHTML = window.SafeTextHtml.sanitize(originalHTML);

            const styledFragments = [];
            let fragmentIndex = 0;

            const collectFragments = (node, tagStack = []) => {
                for (const child of node.childNodes) {
                    if (child.nodeType === 1 && ['STRONG', 'EM', 'U', 'A', 'CODE'].includes(child.tagName)) {
                        const newTag = { tag: child.tagName.toLowerCase(), attrs: {} };
                        for (const attr of child.attributes) newTag.attrs[attr.name] = attr.value;
                        collectFragments(child, [...tagStack, newTag]);
                    } else if (child.nodeType === 3) {
                        const text = child.textContent.trim();
                        if (text.length > 0) {
                            styledFragments.push({
                                raw: text,
                                norm: normalize(text),
                                tags: tagStack,
                                index: fragmentIndex++,
                                origPos: nodeTextPos(child)
                            });
                        }
                    } else if (child.nodeType === 1) {
                        collectFragments(child, tagStack);
                    }
                }
            };
            collectFragments(dummy);
            function nodeTextPos(node) {
                let pos = 0, walker = document.createTreeWalker(dummy, NodeFilter.SHOW_TEXT, null, false);
                let n;
                while ((n = walker.nextNode())) {
                    if (n === node) return pos;
                    pos += n.textContent.length;
                }
                return pos;
            }
            const globalOccurrenceCount = {};
            for (const frag of styledFragments) {
                const key = frag.norm + "|" + JSON.stringify(frag.tags);
                frag.occurrenceIndex = globalOccurrenceCount[key] || 0;
                globalOccurrenceCount[key] = frag.occurrenceIndex + 1;
                frag.sentenceIndex = -1;
            }
            const container = document.createElement('div');
            container.innerHTML = window.SafeTextHtml.sanitize(rewrittenText);

            function getTextNodesAndOffsets(root) {
                const nodes = [];
                const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
                let n;
                while ((n = walker.nextNode())) nodes.push(n);
                const fullText = root.textContent || '';
                const offsets = [];
                let cursor = 0;
                for (const tn of nodes) {
                    const txt = tn.textContent || '';
                    const idx = fullText.indexOf(txt, cursor);
                    if (idx >= 0) {
                        offsets.push({ node: tn, start: idx, end: idx + txt.length });
                        cursor = idx + txt.length;
                    } else {
                        offsets.push({ node: tn, start: cursor, end: cursor + txt.length });
                        cursor += txt.length;
                    }
                }
                return { fullText, offsets };
            }

            function createWrappedNode(text, tagChain) {
                let cur = document.createTextNode(text);
                for (let i = tagChain.length - 1; i >= 0; i--) {
                    const tag = tagChain[i];
                    const el = document.createElement(tag.tag);
                    if (tag.attrs) {
                        Object.entries(tag.attrs).forEach(([k, v]) => el.setAttribute(k, v));
                    }
                    el.appendChild(cur);
                    cur = el;
                }
                return cur;
            }

            styledFragments.sort((a, b) => b.norm.length - a.norm.length);

            const usedRanges = []; // {start, end}

            const origText = dummy.textContent || '';
            const origLen = origText.length;

            for (const frag of styledFragments) {
                if (!frag.norm || frag.tags.length === 0) continue;

                const { fullText: rewrittenPlain, offsets: tnOffsets } = getTextNodesAndOffsets(container);
                const rewrittenLen = rewrittenPlain.length;
                const pat = patternFromText(frag.raw);
                if (!pat) continue;

                const globalRegex = new RegExp(pat, 'ig');

                let candidates = [];
                let match;
                while ((match = globalRegex.exec(rewrittenPlain)) !== null) {
                    const idx = match.index;
                    const before = rewrittenPlain[idx - 1];
                    const after = rewrittenPlain[idx + match[0].length];

                    let wordBoundaryPass = true;
                    if (!(frag.tags && frag.tags.length && frag.tags[frag.tags.length-1].tag === 'a')) {
                        if (isWordChar(before) || isWordChar(after)) wordBoundaryPass = false;
                    }
                    if (!wordBoundaryPass) continue;
                    let alreadyUsed = usedRanges.some(r =>
                        idx < r.end && (idx + match[0].length) > r.start
                    );
                    if (alreadyUsed) continue;
                    let rel = idx / rewrittenLen;
                    candidates.push({idx, len: match[0].length, rel});
                }
                if (candidates.length === 0) continue;
                let relOrig = (frag.origPos || 0) / origLen;
                candidates.sort((a, b) => Math.abs(a.rel - relOrig) - Math.abs(b.rel - relOrig));

                let {idx: foundIndex, len: matchLen} = candidates[0];
                usedRanges.push({start: foundIndex, end: foundIndex + matchLen});

                let matchText = rewrittenPlain.substr(foundIndex, matchLen);
                let targetNodeInfo = null;
                for (const info of tnOffsets) {
                    if (info.start <= foundIndex && foundIndex < info.end) { targetNodeInfo = info; break; }
                }
                if (!targetNodeInfo) continue;

                const tn = targetNodeInfo.node;
                const localIdx = foundIndex - targetNodeInfo.start;
                const piece = (tn.textContent || '').substr(localIdx, matchLen);

                if (piece && (normalize(piece) === normalize(frag.raw))) {
                    const before = tn.textContent.slice(0, localIdx);
                    const matchStr = tn.textContent.slice(localIdx, localIdx + matchLen);
                    const after = tn.textContent.slice(localIdx + matchLen);

                    const fragNode = document.createDocumentFragment();
                    if (before) fragNode.appendChild(document.createTextNode(before));
                    fragNode.appendChild(createWrappedNode(matchStr, frag.tags || []));
                    if (after) fragNode.appendChild(document.createTextNode(after));
                    tn.parentNode.replaceChild(fragNode, tn);
                }
            }

            return container.innerHTML;
        }

        // Unified diff for every type (humanize, paraphraser AND grammar). The API
        // now rewrites the whole text at once (no per-paragraph chunking), so the
        // model may add a heading or return a different number of paragraphs. The old
        // index-based paragraph-to-paragraph mapping dropped/misaligned paragraphs in
        // that case ("eaten" paragraph). diffFullTextToParagraphs diffs the entire
        // document at once, restores the original blank-line spacing and applies the
        // diff-added highlighting — one denominator for all tools.
        const wrapper = quill.root.closest('.form-floating');
        const usePlainDiff = true;

        // Per-paragraph build (styledLines) is only needed for grammar block highlighting.
        if (!usePlainDiff)
        for (let i = 0, j = 0; i < originalLines.length && j < rewrittenLines.length; i++) {
            // console.log('i=', i, 'j=', j, 'orig.html=', originalLines[i], 'rewrite line=', rewrittenLines[j]);
            const orig = originalLines[i];
            const rewrite = rewrittenLines[j];

            const origText = (orig.text || orig.items && orig.items[0].text || '').trim();
            const rewriteText = (rewrite || '').trim();

            if (origText && !rewriteText) {
                j++;
                // continue;
            }

            if (orig.isList) {
                const listItems = [];

                for (let k = 0; k < orig.items.length && j < rewrittenLines.length; k++, j++) {
                    const rewrite = rewrittenLines[j];
                    const origItem = orig.items[k];

                    const liClass = extractLiClass(origItem.html);

                    let styled = applyInlineTags(origItem.html, rewrite);
                    styled = liClass
                        ? `<li class="${liClass}">${styled}</li>`
                        : `<li>${styled}</li>`;
                    listItems.push(styled);
                }

                const wrapped = `<${orig.listTag}>${listItems.join('')}</${orig.listTag}>`;
                // const wrapped = `<p>${listItems.join('')}</p>`;
                styledLines.push(wrapped);
            } else if (orig.isPre) {
                let preLines = [];
                for (let k = 1; k < orig.preLinesCount && j < rewrittenLines.length; k++, j++) {
                    preLines.push(rewrittenLines[j]);
                }
                const preBlock = preLines.join('\n');
                const preClass = orig.html.match(/^<pre\s+([^>]+)>/) ? ' ' + RegExp.$1.trim() : '';
                styledLines.push(`<pre${preClass ? ' ' + preClass : ''}>${preBlock}</pre>`);
                // styledLines.push(`<p>${preBlock}</p>`);
            } else {
                const rewrite = rewrittenLines[j++];
                let styled = rewrite;
                const dummy = document.createElement('div');
                dummy.innerHTML = window.SafeTextHtml.sanitize(orig.html.trim());
                const container = dummy.firstElementChild;
                if (
                    container &&
                    container.children.length === 1 &&
                    container.firstElementChild &&
                    container.firstElementChild.textContent.trim() === container.textContent.trim()
                ) {
                    const wrapperTag = container.firstElementChild;
                    const tagName = wrapperTag.tagName.toLowerCase();

                    if (['strong', 'em', 'u', 'a', 'code'].includes(tagName)) {
                        const attrs = Array.from(wrapperTag.attributes)
                            .map(attr => `${attr.name}="${attr.value}"`)
                            .join(' ');
                        styled = `<${tagName}${attrs ? ' ' + attrs : ''}>${rewrite}</${tagName}>`;

                        styledLines.push(`<${container.tagName.toLowerCase()}>${styled}</${container.tagName.toLowerCase()}>`);
                        // styledLines.push(`<p>${styled}</p>`);
                        continue;
                    }
                }
                if(orig.html.trim() == '<p><br></p>') {
                    // if (j < rewrittenLines.length && rewrittenLines[j] === '') {
                    //     j++;
                    // }
                    styled = orig.html.trim();
                    styledLines.push(styled);
                    continue;
                }
                const wrapperMatch = orig.html.match(/^<(h[1-6]|p|blockquote)[^>]*>[\s\S]*<\/\1>$/);
                if (wrapperMatch) {
                    const tag = wrapperMatch[1];
                    styled = `<${tag}>${rewrite}</${tag}>`;
                    // styled = `<p>${rewrite}</p>`;
                }

                styled = applyInlineTags(orig.html, styled);
                styledLines.push(styled);
            }
        }

        let result = '';
        if (usePlainDiff) {
            // Whole text is diffed at once — structure comes from the model output.
            result = diffFullTextToParagraphs(originalHTML, rewrittenText);
        } else {
            const finalHTML = wrapFoundInSentence(styledLines.join(''), tags);
            result = highlightChangedWords(originalHTML, finalHTML);
        }

        // Grammar with nothing to fix is non-deterministic: the model may return the
        // sentinel phrase below, OR just echo the input unchanged. Detect both so the
        // "no errors" message shows reliably. Exact === is fragile — the model can
        // swap the curly apostrophe (’) for a straight one ('), add whitespace, etc.
        const noErrorMsg = 'Looks great! We didn’t find any errors.';
        const normMsg = s => (s || '')
            .replace(/<[^>]*>/g, ' ')                 // strip any HTML wrapping
            .replace(/[‘’ʼ]/g, "'")    // curly/modifier apostrophe → straight
            .replace(/\s+/g, ' ')
            .trim();
        const modelSaysNoErrors =
            normMsg(rewrittenText).toLowerCase() === normMsg(noErrorMsg).toLowerCase();
        const grammarUnchanged =
            type === 'grammar' &&
            normMsg(htmlToPlainText(originalHTML)) === normMsg(rewrittenText);

        if (modelSaysNoErrors || grammarUnchanged) {
            result = `<h2 class="diff-added">Looks great! We didn’t find any errors.</h2>`;
        }

        result = result.replaceAll("<li></li>", "");
        result = result.replace(/<(ul|ol|p|h[1-6])><\/\1>/gi, "<p><br></p>");
        result = result.replaceAll("<p><strong></strong></p>", "<p><br></p>");
        result = result.replaceAll("&amp;", "&");
        // Strip markdown emphasis (**bold**, *italic*) but keep standalone
        // asterisks — e.g. `SELECT * FROM ...` or multiplication `a * b`.
        result = result
            .replace(/\*\*([^*]+?)\*\*/g, '$1')
            .replace(/\*([^*\s][^*]*?)\*/g, '$1');

        const quillOutput = wrapper.parentNode.querySelector('.quillOutput');
        const resultWordsNum = wrapper.parentNode.querySelector('.resultWordsNum');
        const resultNote = wrapper.parentNode.querySelector('.result-note');
        if (resultNote) resultNote.hidden = true;
        quillOutput.innerHTML = window.SafeTextHtml.sanitize(result);
        normalizeQuillLists(quillOutput);
        const settleResult = () => {
            const resultText = quillOutput?.innerText?.trim() ?? '';
            const resultWords = getSmartWordCount(resultText);
            // gone on grammar re-runs — the renderer swaps the counter for
            // "Issues remaining: N"
            if (resultWordsNum) resultWordsNum.innerText = formatCount(resultWords);
            updateDetectorResultNote(resultNote, resultText, type, language);
            applyResultClamp(quillOutput, resultWords);
        };
        /* the humanizer settles in the frame its text lands in (see
           settleResultPanel); the grammar and paraphrase renderers take over
           the panel after this, so they keep the deferred pass */
        if (type === 'humanize') {
            settleResultPanel(quillOutput);
            settleResult();
        } else {
            setTimeout(settleResult, 0);
        }
        const hlControls = wrapper.parentNode.querySelector('.hl-controls');
        if (hlControls) {
            const changes = quillOutput.querySelectorAll('mark, span.diff-added').length;
            // A grammar check that found nothing renders the "Looks great!" line and
            // has no diff to toggle, so the switch stays hidden there.
            hlControls.classList.toggle('show', !(type === 'grammar' && changes === 0));
            const hlInput = hlControls.querySelector('.hl-toggle input');
            quillOutput.classList.toggle('no-hl', !(hlInput ? hlInput.checked : true));
            // "N changes" chip next to the highlight toggle (as in the sample)
            const diffChip = hlControls.querySelector('.diff-chip');
            if (diffChip) {
                diffChip.textContent = changes ? __('content.hl_changes').replace(':num', formatCount(changes)) : '';
                diffChip.hidden = !changes;
            }
            // the phone toggle reads "Show · N changes" instead of showing the
            // chip (design "1b"); same count, CSS decides which one is visible
            const hlCount = hlControls.querySelector('.hl-count b');
            if (hlCount) {
                hlCount.textContent = changes ? __('content.hl_changes').replace(':num', changes) : '';
                hlCount.parentElement.hidden = !changes;
            }
        }
        updateCopyButtonVisibility(quillOutput);
        document.querySelectorAll('.submitQuill').forEach(function(el) {
            el.removeAttribute('disabled');
        })
        hideLoader();
        enableLeftEditor(quill);
    }

    // The API returns several result variants with quality scores. The best one is
    // shown by default; the tabs let the user inspect and switch to the others.
    function getVariantBar(quill) {
        return quill?.root?.closest('.form-floating')?.parentElement?.querySelector('.variant-bar') || null;
    }

    function syncEditorHeight(quill) {
        const idx = quillInstances.indexOf(quill);
        if (idx !== -1) adjustEditorHeight(idx);
    }

    function hideVariantBar(quill) {
        const bar = getVariantBar(quill);
        if (bar) {
            bar.classList.remove('show');
            bar.innerHTML = '';
            bar.closest('.output-header')?.classList.remove('has-variants');
            syncEditorHeight(quill);
        }
    }

    function extractResultVariants(data, type) {
        if (type !== 'humanize' || !data) return [];

        let variants = Array.isArray(data.variants) ? data.variants : [];

        // Flat API contract: the second take arrives as text2 (+ optional score/score2).
        if (variants.length === 0 && typeof data.text2 === 'string' && data.text2.trim() !== '') {
            variants = [
                { text: data.text, score: data.score },
                { text: data.text2, score: data.score2 },
            ];
        }

        return variants
            .filter(v => v && typeof v.text === 'string' && v.text.trim() !== '')
            .slice(0, 3);
    }

    function renderVariantBar(quill, originalHTML, variants, tags, type, language=null) {
        const bestIdx = variants.reduce(
            (best, v, i, all) => (Number(v.score ?? 0) > Number(all[best].score ?? 0) ? i : best),
            0
        );

        const bar = getVariantBar(quill);
        if (!bar) {
            insertRewrittenTextWithStyling(originalHTML, variants[bestIdx].text, tags, quill, type, language);
            return;
        }

        function selectVariant(i) {
            bar.querySelectorAll('.variant-tab').forEach((btn, j) => {
                btn.classList.toggle('active', j === i);
                btn.setAttribute('aria-selected', String(j === i));
            });
            insertRewrittenTextWithStyling(originalHTML, variants[i].text, tags, quill, type, language);
        }

        bar.innerHTML = '';
        variants.forEach((v, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'variant-tab';
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-selected', 'false');

            const label = document.createElement('span');
            label.textContent = __('content.variant_take').replace(':num', i + 1);
            btn.appendChild(label);

            if (i === bestIdx) {
                const best = document.createElement('span');
                best.className = 'v-best';
                best.textContent = __('content.variant_best');
                btn.appendChild(best);
            }

            btn.addEventListener('click', () => selectVariant(i));
            bar.appendChild(btn);
        });

        // The tabs join the output header row ("Result text" — tabs — toggle),
        // so both panes keep a single chrome row and the texts start level.
        // On narrow screens the title yields its space to the tabs (CSS).
        bar.closest('.output-header')?.classList.add('has-variants');
        bar.classList.add('show');
        selectVariant(bestIdx);
        syncEditorHeight(quill);
    }

    /* On stacked layouts the result panel holds only its loader while a run
       is going (.tool.is-running, async.css); the text box, the detector
       pitch and the footer come in with the result. Whatever measures or
       fills them has to run in that same frame - a pass deferred to the next
       task painted the full text first and then clamped it, and the footer
       under it jumped up the screen (field CLS). So the run state ends as
       soon as the text is in, and the measuring follows synchronously. */
    function settleResultPanel(quillOutput) {
        quillOutput?.closest('.tool')?.classList.remove('is-running');
        /* The height held through a re-run (showLoader) is let go now that
           the result is in - unless a shorter result would pull the page
           under the card up into view, in which case the room stays (the
           panel keeps a little air under the text rather than moving what
           the reader can see). Measured and decided in the same frame. */
        const panel = quillOutput?.closest('.humanResult, .writer-body');
        /* On a stacked layout the room stays whatever the result: the head is
           parked under the header, so a panel that shrank to a shorter result
           pulled the page under the card up into view (a re-run after Show
           all, tester Oct 2026). The text box takes the room instead. */
        if (panel && panel.style.minHeight && !matchMedia('(max-width: 900px)').matches) {
            const held = panel.style.minHeight;
            panel.style.minHeight = '';
            if (panel.getBoundingClientRect().bottom < window.innerHeight) panel.style.minHeight = held;
        }
    }

    /* Phone result clamp (design "1b"): the humanizer result shows ~7 lines
       with a "Show all · N words" pill fading it out; the pill expands the box
       back to the regular scrolling behavior. Only the humanizer panel carries
       the .rs-more markup, so every other tool is a no-op here. Expanding is
       remembered per run (panel dataset), so switching variants doesn't snap
       the box shut again; a new run clears the flag in showLoader. */
    function applyResultClamp(quillOutput, words) {
        const more = quillOutput?.parentElement?.querySelector('.rs-more');
        if (!more) return;
        const panel = quillOutput.closest('.form-floating');
        quillOutput.classList.remove('rs-clamp');
        more.hidden = true;
        // every stacked layout, tablets included (async.css)
        if (!matchMedia('(max-width: 900px)').matches) return;
        if (panel?.dataset.rsExpanded === '1') return;
        quillOutput.classList.add('rs-clamp');
        // clamp only when the text actually overflows the seven-line box
        if (quillOutput.scrollHeight > quillOutput.clientHeight + 12) {
            const btn = more.querySelector('.rs-more-btn');
            // grouped like every other number on the page (formatCount)
            if (btn) btn.textContent = __('content.show_all_words').replace(':num', formatCount(words));
            more.hidden = false;
        } else {
            quillOutput.classList.remove('rs-clamp');
        }
    }
    document.querySelectorAll('.rs-more-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            const panel = btn.closest('.form-floating');
            if (panel) panel.dataset.rsExpanded = '1';
            const output = panel?.querySelector('.quillOutput');
            /* The text opens downwards, from where it was being read. Left
               to scroll anchoring, a tall window kept the box under the text
               in place instead and the page slid down by the whole of the
               unfolded text - the reader who had the first lines in view
               was looking at the last ones. Anchoring is off for the one
               layout the unfolding takes (a scroll back would be animated:
               html has scroll-behavior smooth). */
            const root = document.documentElement;
            const anchoring = root.style.overflowAnchor;
            root.style.overflowAnchor = 'none';
            output?.classList.remove('rs-clamp');
            const more = btn.closest('.rs-more');
            if (more) more.hidden = true;
            void root.offsetHeight;
            root.style.overflowAnchor = anchoring;
        });
    });

    // "Highlight changes" switch — hides/shows the diff highlighting in the result
    // (on by default; the user's choice survives re-runs and variant switching).
    document.querySelectorAll('.hl-controls .hl-toggle input').forEach(function(input) {
        input.addEventListener('change', function() {
            const output = input.closest('.form-floating')?.querySelector('.quillOutput');
            output?.classList.toggle('no-hl', !input.checked);
        });
    });

    function highlightChangedWords(originalHtml, rewriteHtml) {
        function getBlocks(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = window.SafeTextHtml.sanitize(html);
            return Array.from(tempDiv.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6, pre, blockquote'))
                .map(el => el.outerHTML);
        }
        function tokenize(text) {
            const regex = /(<[^>]+>)|([\p{L}\p{N}'’]+)|(\s+|[^\p{L}\p{N}<>'’\s]+)/gu;
            const tokens = [];
            let match;
            while ((match = regex.exec(text)) !== null) {
                tokens.push(match[0]);
            }
            return tokens;
        }
        function extractWords(tokens) {
            const words = [];
            const wordRe = /^[\p{L}\p{N}'’]+$/u;
            tokens.forEach((t, idx) => {
                if (wordRe.test(t)) {
                    words.push({ word: t.toLowerCase(), tokenIndex: idx });
                }
            });
            return words;
        }
        function computeLCS(origWords, rewWords) {
            // Matched (unchanged) rewrite words per SequenceMatcher.
            const a = origWords.map(w => w.word);
            const b = rewWords.map(w => w.word);
            const pairs = new Set();
            for (const [tag, , , j1, j2] of diffOpcodes(a, b)) {
                if (tag === 'equal') {
                    for (let j = j1; j < j2; j++) pairs.add(j);
                }
            }
            return pairs;
        }

        function highlightBlock(originalBlock, rewriteBlock) {
            const origMatch = originalBlock.match(/^<\w+[^>]*>([\s\S]*)<\/\w+>$/);
            const rewriteMatch = rewriteBlock.match(/^<\w+[^>]*>([\s\S]*)<\/\w+>$/);
            if (!origMatch || !rewriteMatch) return rewriteBlock;

            const tag = originalBlock.match(/^<(\w+)/)[1];
            const origText = origMatch[1];
            const rewriteText = rewriteMatch[1];

            const origTokens = tokenize(origText);
            const rewriteTokens = tokenize(rewriteText);

            const origWords = extractWords(origTokens);
            const rewWords = extractWords(rewriteTokens);
            if (origWords.length === 0 || rewWords.length === 0) {
                return `<${tag}>${rewriteText}</${tag}>`;
                // return `<p>${rewriteText}</p>`;
            }
            const matchedRewIndices = computeLCS(origWords, rewWords);
            const rewIndexByToken = new Map();
            rewWords.forEach((w, idx) => rewIndexByToken.set(w.tokenIndex, idx));
            const result = rewriteTokens.map((token, tidx) => {
                if (/^<[^>]+>$/.test(token)) return token;
                if (/^[\p{L}\p{N}'’]+$/u.test(token)) {
                    const rewWordIdx = rewIndexByToken.get(tidx);
                    if (rewWordIdx != null && matchedRewIndices.has(rewWordIdx)) {
                        return token;
                    } else {
                        return `<span class="diff-added">${token}</span>`;
                    }
                }
                return token;
            });

            return `<${tag}>${result.join('')}</${tag}>`;
            // return `<p>${result.join('')}</p>`;
        }

        const origBlocks = getBlocks(originalHtml);
        const rewriteBlocks = getBlocks(rewriteHtml);
        const minLen = Math.min(origBlocks.length, rewriteBlocks.length);

        const highlighted = [];
        for (let i = 0; i < minLen; i++) {
            highlighted.push(highlightBlock(origBlocks[i], rewriteBlocks[i]));
        }
        for (let i = minLen; i < rewriteBlocks.length; i++) {
            highlighted.push(rewriteBlocks[i]);
        }

        return highlighted.join('\n');
    }

    function htmlToPlainText(html) {
        if (!html) return '';
        // Deterministic, string-based (no innerText): block tags -> single \n.
        // </li> already breaks each item, so </ul></ol> must NOT add another \n,
        // otherwise lists produce a spurious blank line at their end.
        let s = String(html)
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/li>/gi, '\n')
            .replace(/<\/(p|div|h[1-6]|pre|blockquote|tr)>/gi, '\n')
            .replace(/<\/(ul|ol)>/gi, '')
            // Remove only real HTML tags (a letter after "<"), so math like
            // p<0.01 or f(x)=0 in plain rewrite text survives.
            .replace(/<\/?[a-zA-Z][^>]*>/g, '');
        // Decode entities without re-parsing tags (the match is only `&...;`).
        if (s.indexOf('&') !== -1) {
            const dec = document.createElement('div');
            s = s.replace(/&(#x?[0-9a-f]+|[a-z0-9]+);/gi, (m) => {
                dec.innerHTML = m;
                return dec.textContent;
            });
        }
        return s
            .replace(/\u00a0/g, ' ')
            .replace(/\r\n/g, '\n')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    // Switching variant tabs re-renders the same (original, rewrite) pair over
    // and over; the diff is pure, so remember the last few results. A handful
    // of entries covers every variant of the current run.
    const fullTextDiffCache = new Map();
    function diffFullTextToParagraphs(originalHtml, rewrittenHtml) {
        const cacheKey = originalHtml.length + ':' + originalHtml + rewrittenHtml;
        const cached = fullTextDiffCache.get(cacheKey);
        if (cached !== undefined) return cached;

        const result = computeFullTextDiff(originalHtml, rewrittenHtml);
        if (fullTextDiffCache.size >= 8) {
            fullTextDiffCache.delete(fullTextDiffCache.keys().next().value);
        }
        fullTextDiffCache.set(cacheKey, result);
        return result;
    }

    function computeFullTextDiff(originalHtml, rewrittenHtml) {
        const wordsOf = s => new Set((s.toLowerCase().match(/[\p{L}\p{N}]+/gu) || []));
        const jaccard = (x, y) => {
            if (!x.size || !y.size) return 0;
            let inter = 0;
            for (const w of x) if (y.has(w)) inter++;
            return inter / (x.size + y.size - inter);
        };

        // --- Original content blocks (paragraphs) + "blank line after this block". ---
        const originalPlain = htmlToPlainText(originalHtml);
        const origBlocks = [];
        for (const raw of originalPlain.split('\n')) {
            const t = raw.trim();
            if (t === '') {
                if (origBlocks.length) origBlocks[origBlocks.length - 1].blankAfter = true;
                continue;
            }
            origBlocks.push({ text: t, words: wordsOf(t), blankAfter: false });
        }

        // --- Rewrite paragraphs (model output, one per line). ---
        const rewParas = htmlToPlainText(rewrittenHtml).split('\n').map(s => s.trim()).filter(Boolean);
        if (!rewParas.length) return '';

        // Monotonically match each rewrite paragraph to its most similar original
        // block. This lets us diff each paragraph against its OWN original (so moved/
        // reworded text keeps reused words unhighlighted) and place blanks correctly.
        const matched = [];
        let oi = 0;
        for (const para of rewParas) {
            const pw = wordsOf(para);
            let best = -1, bestScore = 0.18;
            for (let k = oi; k < origBlocks.length; k++) {
                const sc = jaccard(pw, origBlocks[k].words);
                if (sc > bestScore) { bestScore = sc; best = k; }
            }
            matched.push(best);
            if (best >= 0) oi = best + 1;
        }

        // Highlight each rewrite paragraph by word-diffing it against the ENTIRE
        // original text. Reused words match anywhere via LCS and stay unhighlighted;
        // only genuinely new words get diff-added. This is robust to the model
        // rewording a paragraph heavily or changing paragraph count — the old
        // per-paragraph jaccard match could miss and then highlight a whole
        // paragraph wholesale (origText ended up empty -> everything "new").
        const highlightLocal = (aTokens, rewText) => {
            const b = tokenizePlain(rewText);
            let html = '';
            for (const [tag, , , j1, j2] of diffOpcodes(aTokens, b)) {
                if (tag === 'delete') continue;
                const safe = escapeHtml(b.slice(j1, j2).join(''));
                html += (tag === 'insert' || tag === 'replace')
                    ? `<span class="diff-added">${safe}</span>`
                    : safe;
            }
            return html;
        };
        const originalAllText = origBlocks.map(bl => bl.text).join('\n');
        // One tokenization of the original for the whole render, not one per
        // paragraph — on long texts the repeated pass alone was visible.
        const originalAllTokens = tokenizePlain(originalAllText);
        const htmlParas = rewParas.map(p => highlightLocal(originalAllTokens, p));

        // --- Spacing: reproduce the original's blank lines. ---
        const totalGaps = Math.max(0, origBlocks.length - 1);
        const blankGaps = origBlocks.filter(bl => bl.blankAfter).length;
        // Blank lines are the predominant separator (essay) -> blank between all.
        if (totalGaps > 0 && blankGaps * 2 >= totalGaps) {
            return htmlParas.map(h => `<p>${h}</p>`).join('<p><br></p>');
        }
        // Otherwise place each original blank where it belongs: walk the "blank after
        // block N" markers, emitting an empty <p> once the next paragraph reaches
        // past that block (so deletions/merges keep blanks in the right spot).
        const blankBlocks = [];
        for (let blk = 0; blk < origBlocks.length; blk++) {
            if (origBlocks[blk].blankAfter) blankBlocks.push(blk);
        }
        const out = [];
        let gi = 0;
        for (let i = 0; i < rewParas.length; i++) {
            out.push(`<p>${htmlParas[i]}</p>`);
            if (i === rewParas.length - 1) break;
            const nextBlock = matched[i + 1];
            let blank = false;
            while (gi < blankBlocks.length && nextBlock >= 0 && blankBlocks[gi] < nextBlock) {
                blank = true;
                gi++;
            }
            if (blank) out.push('<p><br></p>');
        }
        return out.join('');
    }

    function mobileSwitcherResult() {
        const screenWidth = window.innerWidth;

        if (screenWidth < 768) {
            const quillForm = document.getElementById('quillForm');
            if (quillForm) quillForm.classList.add('answer-vis');
        }
    }

    document.querySelectorAll('option').forEach(opt => {
        if (!opt.textContent.trim() && !opt.getAttribute('label') && !opt.getAttribute('aria-label')) {
            if(opt.getAttribute('value')) {
                opt.setAttribute('label', opt.getAttribute('value'));
            }

            if(opt.getAttribute('selected')) {
                opt.setAttribute('label', opt.getAttribute('selected'));
            }
        }
    });

    function limitField(el, max, counterId) {
        if (!el) return;
        el.addEventListener('input', () => {
            if (el.value.length > max) {
                el.value = el.value.slice(0, max);
            }
            if (counterId) {
                document.getElementById(counterId).innerText = `${el.value.length} / ${max}`;
            }
        });
    }

    limitField(
        document.getElementById('GenerationTitle'),
        100,
        'titleCounter'
    );

    limitField(
        document.getElementById('GenerationDescription'),
        100,
        'descrCounter'
    );

    function getQuillForType(type) {
        const idx = allQuillEditors.findIndex(el => el.dataset.editorType === type);
        if (idx === -1) return null;
        return quillInstances[idx];
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function parseJsonResponse(response) {
        const contentType = response.headers.get('Content-Type') || '';
        if (!contentType.includes('application/json')) {
            if (response.status === 401 || response.status === 419) {
                throw new Error(__('content.modal_error_expired_descr'));
            }

            throw new Error(__('content.modal_error_descr'));
        }

        return response.json();
    }

    /* Risk-based Turnstile challenge: the server answers 403 with
       error_type "challenge_required" once a guest has used up its free
       runs; we solve the (usually invisible) widget and retry once. */
    let turnstileScriptPromise = null;
    function loadTurnstileScript() {
        if (window.turnstile) return Promise.resolve();
        if (!turnstileScriptPromise) {
            turnstileScriptPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.onload = resolve;
                script.onerror = () => {
                    turnstileScriptPromise = null;
                    reject(new Error('Turnstile failed to load'));
                };
                document.head.appendChild(script);
            });
        }
        return turnstileScriptPromise;
    }

    /* Resolves with the token, null when the check could not be passed, or
       false when the visitor closed it — the caller says nothing then. */
    async function obtainChallengeToken(sitekey) {
        try {
            await loadTurnstileScript();
        } catch (_) {
            return null;
        }
        return new Promise((resolve) => {
            /* Managed Turnstile: most checks pass without interaction, so the
               overlay starts click-through and fully transparent. Only when
               Cloudflare decides the visitor must interact does the widget
               surface, centered and backdropped, where it cannot be missed. */
            const overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:transparent;pointer-events:none;transition:background .2s;';
            const card = document.createElement('div');
            card.style.cssText = 'visibility:hidden;background:#fff;border-radius:12px;padding:24px;box-shadow:0 10px 40px rgba(0,0,0,.25);text-align:center;max-width:90vw;';
            const title = document.createElement('div');
            title.textContent = t('content.challenge_title', 'Quick security check');
            title.style.cssText = 'font-size:16px;font-weight:600;margin-bottom:12px;color:#0f172a;';
            const slot = document.createElement('div');
            const cancel = document.createElement('button');
            cancel.type = 'button';
            cancel.textContent = t('content.challenge_cancel', 'Cancel');
            cancel.style.cssText = 'margin-top:12px;padding:4px 8px;background:none;border:0;color:#475569;font:inherit;font-size:14px;text-decoration:underline;cursor:pointer;';
            card.appendChild(title);
            card.appendChild(slot);
            card.appendChild(cancel);
            overlay.appendChild(card);
            document.body.appendChild(overlay);
            let widgetId = null;
            let settled = false;
            let failures = 0;
            let hangTimer = null;
            const done = (token) => {
                if (settled) return;
                settled = true;
                clearTimeout(hangTimer);
                try {
                    if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
                } catch (_) {}
                overlay.remove();
                resolve(token);
            };
            const reveal = () => {
                overlay.style.background = 'rgba(15,23,42,.55)';
                overlay.style.pointerEvents = 'auto';
                card.style.visibility = 'visible';
            };
            cancel.addEventListener('click', () => done(false));
            try {
                widgetId = window.turnstile.render(slot, {
                    sitekey: sitekey,
                    appearance: 'interaction-only',
                    retry: 'never',
                    'before-interactive-callback': () => {
                        /* The visitor has the widget and a Cancel button now;
                           the hang guard below must not pull it from under them. */
                        clearTimeout(hangTimer);
                        reveal();
                    },
                    callback: (token) => done(token),
                    /* A failed attempt is not a failed check. Right after the
                       checkbox click Cloudflare often fails the first round
                       (flaky mobile network, DevTools device emulation) and
                       passes the next one. Giving up on the first error threw
                       away a check the visitor was passing, together with the
                       run in progress. Run it again, in view, a few times. */
                    'error-callback': (code) => {
                        failures += 1;
                        console.warn('Turnstile error', code);
                        if (failures >= 3) {
                            done(null);
                            return true;
                        }
                        reveal();
                        setTimeout(() => {
                            if (settled) return;
                            try {
                                window.turnstile.reset(widgetId);
                            } catch (_) {
                                done(null);
                            }
                        }, 1000);
                        return true;
                    },
                    'expired-callback': () => {
                        try {
                            window.turnstile.reset(widgetId);
                        } catch (_) {
                            done(null);
                        }
                    }
                });
            } catch (_) {
                done(null);
                return;
            }
            /* If Cloudflare never calls back and never asks for interaction
               (blocked script), release the submit instead of hanging. */
            hangTimer = setTimeout(() => done(null), 120000);
        });
    }

    async function waitForHumanizeJob(jobId, onProgress = null) {
        const headers = {
            'Accept': 'application/json',
            'X-Client-Fingerprint': window.__clientFingerprint || ''
        };
        let lastProgressVersion = 0;

        for (;;) {
            await sleep(2000);
            const response = await (window.csrfFetch || window.fetch)(`/humanize-jobs/${encodeURIComponent(jobId)}`, {
                method: 'GET',
                headers,
                credentials: 'same-origin'
            });

            if (response.status === 419 || response.status === 401) {
                throw new Error(__('content.modal_error_expired_descr'));
            }

            const result = await parseJsonResponse(response);
            const progressVersion = Number(result.progress?.version) || 0;
            if (progressVersion > lastProgressVersion) {
                lastProgressVersion = progressVersion;
                if (typeof onProgress === 'function') onProgress(result.progress);
            }

            if (result.status === 'completed' || result.data?.text) {
                return result;
            }

            if (result.status === 'failed' || result.status === 'cancelled' || result.error) {
                const error = new Error(result.error || __('content.modal_error_rewrite_descr'));
                if (result.error_type === 'limit') {
                    error.isLimitError = true;
                }
                throw error;
            }
        }
    }

    document.getElementById('quillForm').addEventListener('submit', async function(e) {
        e.preventDefault();
        window.__rewriteStartTime = performance.now();
        const typeGeneration = this.getAttribute('data-form-type');
        const isGeneration = typeGeneration === 'generation';
        const isParaphraser = typeGeneration === 'paraphraser';
        const isGrammar = typeGeneration === 'grammar';
        const generationType = document.querySelector('input[name="type_generation"]:checked')?.value || 'Essay';
        const generationTitle = document.querySelector('#GenerationTitle')?.value.trim() || '';
        const generationDescr = document.querySelector('#GenerationDescription')?.value || '';
        const generationWords = document.querySelector('#numWords')?.value || 100;
        const generationLanguage = document.querySelector('.w-langs .w-option[data-selected="true"]')?.getAttribute('data-value') || 'English';

        /* humanize reads #humanizeStyle, the hidden input the style pills write —
           the same shape as the paraphraser's #paraphraseStyle. The old
           dropdown selector stays as the fallback: the embeddable iframe page
           still carries .w-style with its .w-option rows. */
        const selectedStyle = isGeneration ?
            document.querySelector('.generation-style .w-option[data-selected="true"]')?.getAttribute('data-value') || 'casual' :
            isParaphraser ?
                /* .value, not getAttribute: the style tabs write the property,
                   the attribute never leaves its initial "standard" */
                document.querySelector('#paraphraseStyle')?.value || 'standard' :
                document.querySelector('#humanizeStyle')?.value
                    || document.querySelector('.w-style:not(.generation-style) .w-option[data-selected="true"]')?.getAttribute('data-value')
                    || 'casual';
        const grammarGoal = document.querySelector('#grammarGoal')?.value || 'general';
        const paraphraseStrength = document.querySelector('#paraphraseStrength')?.value || 'medium';
        const paraphraseLength = document.querySelector('#paraphraseLength')?.value || 'same';
        const paraphraseInstructions = document.querySelector('#paraphraseInstructions')?.value?.trim() || '';
        const paraphraseFreeze = (document.querySelector('#paraphraseFreeze')?.value || '')
            .split(/[,\n]/)
            .map(value => value.trim())
            .filter(Boolean)
            .slice(0, 50);

        const quill = getQuillForType(typeGeneration);
        if (!quill && !isGeneration) {
            alert('No editor found for type: ' + type);
            return;
        }
        const plainText = quill?.getText().trim() || '';
        const htmlText = quill?.root.innerHTML.trim() || '';
        originalHtmlText = htmlText;
        const wordCount = getSmartWordCount(plainText);
        const file = dzInstance?.files?.[0] || null;

        const loaderTimeWordsCount = isGeneration ? generationWords : wordCount;

        // Per-request word cap: red counter + message in the result pane
        // (design-sample behavior), never a popup. Runs before the daily-quota
        // checks so oversized text doesn't trigger the signup modal.
        if (!isGeneration && wordCount > REQUEST_WORD_LIMIT) {
            makeError('.textMaxLengthBlock', quill);
            const pane = quill?.root.closest('.form-floating');
            const resultPlace = quill?.root.closest('.fields')?.querySelector('.quillOutput .place');
            const maxMsg = pane?.querySelector('.textMaxLengthBlock');
            if (resultPlace && maxMsg) {
                if (!resultPlace.dataset.defaultText) resultPlace.dataset.defaultText = resultPlace.innerHTML;
                resultPlace.innerHTML = maxMsg.innerHTML;
            }
            return;
        }

        if ((!isLoggedIn && wordLimit <= 0) || (!isLoggedIn && wordCount > wordsRest)) {
            if (isGeneration || isParaphraser || isGrammar) {
                if (!tryShowUpgradeBannerModal()) {
                    const signupModal = document.getElementById('signupModal');
                    if (signupModal) signupModal.classList.add('modal-open');
                }
            } else {
                const signupModal = document.getElementById('signupModal');
                if (signupModal) signupModal.classList.add('modal-open');
            }
            document.body.classList.add('modal-open');
            document.querySelectorAll('.submitQuill').forEach(el => {
                el.removeAttribute('disabled');
            });
            return;
        }

        if ((isLoggedIn && wordLimit <= 0) || (isLoggedIn && wordCount > wordsRest)) {
            /* The only path that used to rely on the dialog's markup for its
               wording — which is why the cap message sat in the served HTML of
               a page nobody had submitted anything on yet. It says its piece
               like the other seven callers now. */
            showLimitModal(__('content.modal_limit_title'), __('content.modal_limit'));
            document.querySelectorAll('.submitQuill').forEach(el => {
                el.removeAttribute('disabled');
            });
            return;
        }

        const minimumWords = minimumWordsForMode(typeGeneration);
        if (!isGeneration && wordCount < minimumWords) {
            showLimitModal(
                __('content.text_too_short_title'),
                __('content.text_too_short').replace(/:min/g, formatCount(minimumWords))
            );
            document.querySelectorAll('.submitQuill').forEach(el => el.removeAttribute('disabled'));
            return;
        }

        if (isGeneration) {
            if (!generationTitle || !/\p{L}/u.test(generationTitle)) {
                makeError('textTitleError', null);
                return;
            }
        }

        document.querySelectorAll('.submitQuill').forEach(function(el) {
            el?.setAttribute('disabled', 'disabled');
        })
        let provider;
        if(!isGeneration) {
            const wrapper = quill.root.closest('.form-floating');
            provider = wrapper.querySelector('.submitQuill').getAttribute('data-rewrite-provider') || 'external';
            /* a re-run on a stacked layout keeps the panel at the height of
               the result this is about to empty (see showLoader) */
            holdResultPanel(wrapper.parentElement.querySelector('.humanResult'));
            wrapper.parentElement.querySelector('.quillOutput').innerHTML = '';
            /* the grammar renderer replaces the words counter with "Issues
               remaining: N", so this node is gone on a repeat check — without
               the guard the second submit died right here, before the loader */
            const resultCounter = wrapper.parentElement.querySelector('.resultWordsNum');
            if (resultCounter) resultCounter.innerText = 0;
            hideVariantBar(quill);
            wrapper.parentElement.querySelector('.hl-controls')?.classList.remove('show');
            const resultNote = wrapper.parentElement.querySelector('.result-note');
            if (resultNote) resultNote.hidden = true;
            const diffChip = wrapper.parentElement.querySelector('.diff-chip');
            if (diffChip) diffChip.hidden = true;
        } else {
            provider = document.querySelector('#AIWriter .submitQuill').getAttribute('data-rewrite-provider') || 'external';
        }

        const turnstileEl = document.querySelector('[name="cf-turnstile-response"]');
        const turnstileToken = turnstileEl ? turnstileEl.value : null;

        const pathParts = window.location.pathname.split('/');
        const firstPart = pathParts[1];
        const isLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(firstPart);
        const locale = isLocale ? firstPart : '';
        const rewriteUrl = locale ? `/${locale}/rewrite` : '/rewrite';
        const formData = new FormData();
        formData.append('text', plainText);
        formData.append('html', htmlText);
        formData.append('style', selectedStyle);
        formData.append('type_generation', typeGeneration);
        if (typeGeneration === 'generation') {
            formData.append('is_generation', '1');
        } else if (typeGeneration === 'grammar') {
            formData.append('is_grammar', '1');
            formData.append('grammar_goal', grammarGoal);
        } else if (typeGeneration === 'paraphraser') {
            formData.append('is_paraphraser', '1');
            formData.append('paraphrase_strength', paraphraseStrength);
            formData.append('paraphrase_length', paraphraseLength);
            formData.append('paraphrase_freeze', JSON.stringify(paraphraseFreeze));
            formData.append('paraphrase_instructions', paraphraseInstructions);
        }

        if (turnstileToken) {
            formData.append('cf-turnstile-response', turnstileToken);
        }
        // const payload = {
        //     text: plainText,
        //     html: htmlText,
        //     style: selectedStyle,
        //     ...(turnstileToken ? { 'cf-turnstile-response': turnstileToken } : {})
        // };

        if (isGeneration) {
            formData.append('generation_type', generationType);
            formData.append('generation_title', generationTitle);
            formData.append('generation_descr', generationDescr);
            formData.append('generation_words', generationWords);
            formData.append('generation_language', generationLanguage);
        }

        if (file) {
            formData.append('file', file);
        }

        // if (isGeneration) {
        //     Object.assign(payload, {
        //         is_generation: true,
        //         generation_type: generationType,
        //         generation_title: generationTitle,
        //         generation_descr: generationDescr,
        //         generation_words: generationWords,
        //         generation_language: generationLanguage,
        //     });
        // }

        if (!navigator.onLine) {
            showLimitModal(__('content.modal_error_connection_title'), __('content.modal_error_connection_descr'));
            hideLoader();
            enableLeftEditor(quill);
            return;
        }

        try {
            showLoader(typeGeneration, loaderTimeWordsCount, generationLanguage);
            disableLeftEditor(quill);
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                const headers = {
                    'X-CSRF-TOKEN': csrfToken,
                    'X-Client-Fingerprint': window.__clientFingerprint || ''
                };
                if (!file) {
                    headers['Content-Type'] = 'application/json';
                }
                const payloadObj = !file ? {
                    text: plainText,
                    html: htmlText,
                    style: selectedStyle,
                    type_generation: typeGeneration,
                    ...(typeGeneration === 'generation' ? { is_generation: true } : typeGeneration === 'grammar' ? { is_grammar: true } : typeGeneration === 'paraphraser' ? { is_paraphraser: true } : {}),
                    ...(isGrammar ? { grammar_goal: grammarGoal } : {}),
                    ...(isParaphraser ? {
                        paraphrase_strength: paraphraseStrength,
                        paraphrase_length: paraphraseLength,
                        paraphrase_freeze: paraphraseFreeze,
                        paraphrase_instructions: paraphraseInstructions
                    } : {}),
                    ...(turnstileToken ? { 'cf-turnstile-response': turnstileToken } : {}),
                    ...(isGeneration ? { generation_type: generationType, generation_title: generationTitle, generation_descr: generationDescr, generation_words: generationWords, generation_language: generationLanguage } : {})
                } : null;
                const body = file ? formData : JSON.stringify(payloadObj);
                /* csrfFetch, so a tab that has been open past the session
                   lifetime retries once with a fresh token instead of losing
                   the run — and refuses to retry a signed-in request as a
                   guest, which would spend the guest allowance and keep the
                   result out of the account's history. */
                const send = window.csrfFetch || window.fetch;
                let response = await send(rewriteUrl, {
                    method: 'POST',
                    headers: headers,
                    body: body,
                    credentials: 'same-origin'
                });

                if (response.status === 403) {
                    let challengeInfo = null;
                    try {
                        challengeInfo = await response.clone().json();
                    } catch (_) {}

                    if (challengeInfo && challengeInfo.error_type === 'challenge_required' && challengeInfo.sitekey) {
                        const challengeToken = await obtainChallengeToken(challengeInfo.sitekey);
                        if (challengeToken) {
                            let retryBody;
                            if (file) {
                                formData.set('cf-turnstile-response', challengeToken);
                                retryBody = formData;
                            } else {
                                retryBody = JSON.stringify({ ...payloadObj, 'cf-turnstile-response': challengeToken });
                            }
                            response = await send(rewriteUrl, {
                                method: 'POST',
                                headers: headers,
                                body: retryBody,
                                credentials: 'same-origin'
                            });
                        }

                        if (response.status === 403) {
                            let stillBlocked = null;
                            try {
                                stillBlocked = await response.clone().json();
                            } catch (_) {}
                            if (stillBlocked && stillBlocked.error_type === 'challenge_required') {
                                if (challengeToken !== false) {
                                    showLimitModal(
                                        t('content.challenge_failed_title', 'Verification did not go through'),
                                        t('content.challenge_failed_descr', 'Your text is still here. Please try again.')
                                    );
                                }
                                hideLoader();
                                enableLeftEditor(quill);
                                document.querySelectorAll('.submitQuill').forEach(el => {
                                    el.removeAttribute('disabled');
                                });
                                return;
                            }
                        }
                    }
                }

                if (response.status === 429 || response.status === 503) {
                    let result = null;
                    try {
                        result = await parseJsonResponse(response);
                    } catch (_) {}

                    if ((result && result.error_type === 'admission') || response.status === 503) {
                        showLimitModal(
                            __('content.modal_limit_title'),
                            (result && (result.message || result.error)) || __('content.modal_limit')
                        );
                        hideLoader();
                        enableLeftEditor(quill);
                        document.querySelectorAll('.submitQuill').forEach(el => {
                            el.removeAttribute('disabled');
                        });
                        return;
                    }

                    if (!isLoggedIn) {
                        if (isGeneration || isParaphraser || isGrammar) {
                            if (!tryShowUpgradeBannerModal()) {
                                const signupModal = document.getElementById('signupModal');
                                if (signupModal) signupModal.classList.add('modal-open');
                            }
                        } else {
                            const signupModal = document.getElementById('signupModal');
                            if (signupModal) signupModal.classList.add('modal-open');
                        }
                        document.body.classList.add('modal-open');
                        document.querySelectorAll('.submitQuill').forEach(el => {
                            el.removeAttribute('disabled');
                        });
                        return;
                    }

                    showLimitModal(
                        __('content.modal_limit_title'),
                        (result && (result.message || result.error)) || __('content.modal_error_descr_user')
                    );
                    hideLoader();
                    enableLeftEditor(quill);
                    document.querySelectorAll('.submitQuill').forEach(el => {
                        el.removeAttribute('disabled');
                    });
                    return;
                }

                if (response.status === 419) {
                    /* csrfFetch already refreshed the token and repeated this
                       once, so reaching here means the second one failed too.
                       Someone signed in is told they are not any more — that is
                       the fact that changes what they should do next. */
                    showLimitModal(
                        isLoggedIn ? t('content.modal_signed_out_title', 'You have been signed out') : __('content.modal_error_expired_title'),
                        isLoggedIn
                            ? t('content.modal_signed_out_descr', 'Your session ended while this page was open, so nothing was saved to your account. Your text is still here — <a href="/login" target="_blank" rel="noopener">sign in again</a> and try once more.')
                            : __('content.modal_error_expired_descr')
                    );

                    document.querySelectorAll('.modal-body .greenBtn').forEach(button => {
                        const handler = () => {
                            window.location.reload();
                            button.removeEventListener('click', handler);
                        };
                        button.addEventListener('click', handler);
                    });

                    hideLoader();
                    enableLeftEditor(quill);
                    return;
                }

                if (response.status === 401) {
                    showLimitModal(__('content.modal_error_expired_title'), __('content.modal_error_expired_descr'));

                    document.querySelectorAll('.modal-body .greenBtn').forEach(button => {
                        const handler = () => {
                            window.location.reload();
                            button.removeEventListener('click', handler);
                        };
                        button.addEventListener('click', handler);
                    });

                    hideLoader();
                    enableLeftEditor(quill);
                    return;
                }

                let result = await parseJsonResponse(response);

                if (isAcademicUnsupportedLanguageResponse(result)) {
                    showAcademicUnsupportedLanguageModal();
                    return;
                }

                if (result.error) {

                    if (!navigator.onLine) {
                        showLimitModal(__('content.modal_error_connection_title'), __('content.modal_error_connection_descr'));
                        hideLoader();
                        enableLeftEditor(quill);
                        return;
                    }
                    if (result.error_type === 'limit') {
                        showLimitModal(__('content.modal_limit_title'), result.message || result.error || __('content.modal_error_descr_user'));
                        return;
                    }
                    showLimitModal(__('content.modal_error_title'), result.message);
                    return;
                }

                if (result.queued && result.job_id) {
                    result = await waitForHumanizeJob(
                        result.job_id,
                        progress => restartLoaderForProgress(
                            progress,
                            typeGeneration,
                            loaderTimeWordsCount,
                            generationLanguage
                        )
                    );
                }

                if (isAcademicUnsupportedLanguageResponse(result)) {
                    showAcademicUnsupportedLanguageModal();
                    return;
                }

                if (isUnsupportedLanguageResponse(result)) {
                    showUnsupportedLanguageModal(result, typeGeneration, quill);
                    return;
                }

                if (result.data?.text) {
                    function normalizeKey(v) {
                        return String(v ?? '')
                            .trim()
                            .toLowerCase()
                            .replace(/\s+/g, '_')
                            .replace(/-+/g, '_');
                    }

                    if (isGeneration) {
                        const AIWriterHeader = document.querySelector('#AIWriter .writer-header');
                        if (AIWriterHeader) {
                            AIWriterHeader.style.display = 'none';
                        }
                        document.querySelector('#AIWriter .writer-body').style.display = 'none';
                        document.querySelector('#AIWriter .quillFooter').style.display = 'none';

                        const generationHumanBlock = document.getElementById('humanGenResult');
                        const generateResultField = document.getElementById('quillGenOutput');

                        generationHumanBlock.style.display = 'block';
                        generateResultField.innerText = result.data.text;
                        adjustResultBlockHeight('quillGenOutput');
                        generateResultField.scrollTop = 0;

                        const typeKey = normalizeKey(generationType);
                        generationHumanBlock.querySelector('.icon-type')
                            .classList.add(typeKey + '-type');

                        // type label
                        const typeLabel =
                            window.APP_I18N?.writerTypes?.[typeKey] ??
                            window.APP_I18N?.writerTypes?.[generationType] ??
                            generationType;

                        // language label
                        const langKey = normalizeKey(generationLanguage);
                        const langLabel =
                            window.APP_I18N?.languages?.[langKey] ??
                            window.APP_I18N?.languages?.[generationLanguage] ??
                            generationLanguage;

                        generationHumanBlock.querySelector('#genType').innerText = typeLabel;
                        generationHumanBlock.querySelector('.langs-img').innerText = langLabel;

                        generationHumanBlock.querySelector('.words-img span').innerText =
                            getSmartWordCount(result.data.text);

                        generationHumanBlock.querySelector('.h3').innerText = generationTitle;

                        document.getElementById('resetHumanizedGeneration').addEventListener('click', function () {
                            resetGeneratedHumanizedResult();
                        });
                    } else {
                        const resultVariants = extractResultVariants(result.data, typeGeneration);
                        const resultLanguage = result.data.detected_lang || result.data.language;
                        if (resultVariants.length > 1) {
                            renderVariantBar(quill, originalHtmlText, resultVariants, result.data.tags, typeGeneration, resultLanguage);
                        } else {
                            insertRewrittenTextWithStyling(originalHtmlText, result.data.text, result.data.tags, quill, typeGeneration, resultLanguage);
                        }
                    }

                    if (result?.data?.id) {
                        let finalHTML = '';
                        if(isGeneration) {
                            const genEl = document.getElementById('quillGenOutput');
                            finalHTML = genEl ? genEl.innerHTML.trim() : '';
                        } else {
                            const outputEl = quill?.root?.closest('.form-floating')?.parentElement?.querySelector('.quillOutput')
                                || document.getElementById('quillOutput');
                            finalHTML = outputEl ? outputEl.innerHTML.trim() : '';
                        }
                        if (finalHTML) {
                            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                            fetch('/save-rewritten-html', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-CSRF-TOKEN': csrfToken
                                },
                                body: JSON.stringify({
                                    text_id: result.data.id,
                                    rewritten_html: finalHTML
                                })
                            }).catch(console.error);
                        }
                    }
                    if(!isGeneration) {
                        const wrapper = quill?.root?.closest('.form-floating');
                        if (wrapper) {
                            const isPlainHumanResult = Boolean(wrapper.parentNode?.querySelector('.human-result-plain'));
                            const selector = isPlainHumanResult
                                ? '.copyFromQuillText button'
                                : '.copyFromQuill button, .copyFromQuillText button';
                            wrapper
                                .querySelectorAll(selector)
                                .forEach(btn => btn.removeAttribute('disabled'));
                        }
                    }
                    if (isGrammar || isParaphraser) {
                        window.dispatchEvent(new CustomEvent('writing-tool:result', {
                            detail: {
                                type: typeGeneration,
                                data: result.data,
                                sourceText: plainText
                            }
                        }));
                    }
                    mobileSwitcherResult();
                    /* second jump, when there is something to see: the phone
                       re-aligns on the panel, a desktop shows the whole tool */
                    scrollToFinishedResult(loaderContainer.closest('.humanResult, .writer-body'));
                    /* The viewport cap of .tool.has-result (core.css) fits the
                       finished card under the sticky header, with the panes
                       scrolling internally. The grammar and paraphrase pages
                       share the humanizer's skeleton, so they take the same
                       class - without it their cards grew past the window and
                       the footer of the tool was cut off. The writer keeps its
                       own content-sized layout. */
                    if (typeGeneration === 'humanize' || typeGeneration === 'grammar' || typeGeneration === 'paraphraser') {
                        quill?.root?.closest('.tool')?.classList.add('has-result');
                    }
                    if (typeGeneration === 'humanize') {
                        // result-feedback.js: sign-in strip + thumbs for this run —
                        // guests carry a guest_texts id, signed-in users a user_texts id
                        window.dispatchEvent(new CustomEvent('upsell:result', {
                            detail: {
                                guestTextId: result?.data?.guest_text_id ?? null,
                                userTextId: result?.data?.id ?? null
                            }
                        }));
                    }
                } else {
                    showLimitModal(__('content.modal_error_rewrite_title'), __('content.modal_error_rewrite_descr'));
                }
        } catch (error) {

            if (!navigator.onLine) {
                showLimitModal(__('content.modal_error_connection_title'), __('content.modal_error_connection_descr'));
                hideLoader();
                enableLeftEditor(quill);
                return;
            }

            console.error(error);
            /* The session died under the request. csrf.js has already said so,
               and it is not a rewrite failure — saying "something went wrong"
               on top of it would bury the one thing that helps. */
            if (error?.sessionExpired) return;
            if (error?.isLimitError) {
                showLimitModal(__('content.modal_limit_title'), error.message || __('content.modal_error_descr_user'));
                return;
            }
            showLimitModal(__('content.modal_error_title'), error?.message || __('content.modal_error_descr'));
        } finally {

            hideLoader();
            enableLeftEditor(quill);

        }
    });

    function resetGeneratedHumanizedResult() {
        const AIWriterHeader = document.querySelector('#AIWriter .writer-header');
        if (AIWriterHeader) {
            AIWriterHeader.style.display = 'flex';
        }
        document.querySelector('#AIWriter .writer-body').style.display = 'block';
        document.querySelector('#AIWriter .quillFooter').style.display = 'flex';
        const generationHumanBlock = document.getElementById('humanGenResult');
        const generateResultField = document.getElementById('quillGenOutput');
        generationHumanBlock.style.display = 'none';
        generateResultField.innerText = '';
        generationHumanBlock.querySelector('.icon-type').className = 'icon-type';
        generationHumanBlock.querySelector('.words-img span').innerText = 0;
        generationHumanBlock.querySelector('.langs-img').innerText = 'English';
        generationHumanBlock.querySelector('.h3').innerText = '';
        document.removeEventListener("click", resetGeneratedHumanizedResult);
    }

    const copyBtns = document.querySelectorAll('.copyBtn button');

    // Copy feedback: the button itself says "Copied" for a moment. It reads better
    // than the tooltip that used to float above it, and it works the same way on
    // every tool (the detector does it too).
    function flashCopied(button) {
        if (!button || button.dataset.copyFlash === '1') return;

        const original = button.textContent;
        button.dataset.copyFlash = '1';
        button.classList.add('is-copied');
        button.textContent = __('content.copied');
        setTimeout(() => {
            button.textContent = original;
            button.classList.remove('is-copied');
            delete button.dataset.copyFlash;
        }, 1500);
    }

    function updateCopyButtonVisibility(outputEl) {
        // the .place placeholder ("New text will appear here") is not copyable content
        const hasContent = !outputEl.querySelector('.place')
            && (outputEl.textContent || outputEl.innerText || '').trim().length > 0;
        const isPlainHumanResult = Boolean(outputEl.closest('.human-result-plain'));
        const buttons = outputEl.parentElement.querySelectorAll(
            isPlainHumanResult
                ? '.copyFromQuillText button'
                : '.copyFromQuill button, .copyFromQuillText button'
        );
        if(hasContent) {
            buttons.forEach(btn => btn.removeAttribute('disabled'));
        } else {
            buttons.forEach(btn => btn.setAttribute('disabled', 'true'));
        }
    }

    copyBtns.forEach(copyBtn => {
        copyBtn?.addEventListener('click', async (e) => {
            const btn = e.currentTarget;
            const target = btn?.dataset?.target;
            const wrapper = copyBtn.closest('.form-floating');
            let original = wrapper?.querySelector('.quillOutput');
            const dataId = btn?.getAttribute('data-field-id');

            if(dataId) {
                const generateTextField = document.getElementById(dataId);
                original = generateTextField;
            }

            if (!original || !target) return;

            const makeCleanClone = () => {
                const clone = original.cloneNode(true);
                /* the writing-tools review markup is interactive: the ↻ and
                   word-count controls are dropped, the change chips and
                   sentence wrappers unwrap to their text — otherwise "Copy
                   text" reproduced the raw buttons markup */
                clone.querySelectorAll('.paraphrase-sentence-variants, .grammar-sent-btn, .grammar-long-sentence, .stream-status, .stream-caret')
                    .forEach(el => el.remove());
                clone.querySelectorAll('span[class^="diff-"], .paraphrase-sentence, .paraphrase-change, .paraphrase-frozen, .grammar-sent, .grammar-inline-issue, .grammar-applied').forEach(span => {
                    const parent = span.parentNode;
                    if (!parent) return;
                    while (span.firstChild) parent.insertBefore(span.firstChild, span);
                    parent.removeChild(span);
                });
                return clone;
            };

            const buildPlainText = (root) => {
                root.querySelectorAll('br').forEach(br => br.replaceWith('\n'));

                const blocks = root.querySelectorAll('p,h1,h2,h3,h4,h5,h6,li');
                const lines = [];
                blocks.forEach(el => {
                    let t = (el.innerText ?? '').replace(/[ \t]+\n/g, '\n');
                    if (el.tagName === 'P' && (/^\s*$/.test(t))) {
                        lines.push('');
                    } else {
                        t = t.replace(/\n+$/g, '');
                        lines.push(t);
                    }
                });

                let txt = lines.join('\n');

                txt = txt.replace(/\r\n/g, '\n').replace(/[ \t]+\n/g, '\n').trim();
                return txt.replace(/\n/g, '\r\n');
            };

            const writeToClipboard = async ({ html, text }) => {
                if (window.ClipboardItem && navigator.clipboard?.write) {
                    try {
                        const data = {};
                        if (html) data['text/html'] = new Blob([html], { type: 'text/html' });
                        if (text) data['text/plain'] = new Blob([text], { type: 'text/plain' });
                        if (Object.keys(data).length) {
                            await navigator.clipboard.write([new ClipboardItem(data)]);
                            return true;
                        }
                    } catch (_) {}
                }

                if (html && !text) {
                    const temp = document.createElement('div');
                    temp.style.position = 'fixed';
                    temp.style.left = '-9999px';
                    temp.style.top = '0';
                    temp.style.opacity = '0';
                    temp.style.userSelect = 'text';
                    temp.setAttribute('aria-hidden', 'true');
                    temp.innerHTML = html;
                    document.body.appendChild(temp);

                    const range = document.createRange();
                    range.selectNodeContents(temp);
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                    const ok = document.execCommand('copy');
                    sel.removeAllRanges();
                    document.body.removeChild(temp);
                    return ok;
                }

                if (text) {
                    const ta = document.createElement('textarea');
                    ta.value = text;
                    ta.setAttribute('readonly', '');
                    ta.setAttribute('aria-hidden', 'true');
                    ta.style.position = 'fixed';
                    ta.style.top = '-9999px';
                    ta.style.left = '0';
                    ta.style.opacity = '0';
                    document.body.appendChild(ta);
                    ta.select();
                    const ok = document.execCommand('copy');
                    document.body.removeChild(ta);
                    return ok;
                }

                return false;
            };

            let success = false;

            if (target === 'text') {
                const clone = makeCleanClone();
                const hasStructuredBlocks = clone.querySelector('p,h1,h2,h3,h4,h5,h6,li');
                let text = "";
                if (hasStructuredBlocks) {
                    text = buildPlainText(clone);
                } else {
                    text = clone.innerHTML
                        .replace(/<br\s*\/?>/gi, '\n')
                        .replace(/&nbsp;/g, ' ')
                        .trim();
                }
                success = await writeToClipboard({ text });
            }

            if (target === 'html') {
                const clone = makeCleanClone();

                clone.querySelectorAll('p').forEach(p => {
                    if (p.innerHTML.trim() === '<br>') {
                        p.innerHTML = '&nbsp;';
                    }
                });

                const html = clone.innerHTML;
                const text = buildPlainText(clone);

                success = await writeToClipboard({ html, text });
            }

            if (success) {
                flashCopied(btn);
            } else {
                alert(typeof __ !== 'undefined' && __('content.copy_failed') ? __('content.copy_failed') : 'Failed to copy');
            }
        });
    });

    /* Every "Try a sample" click is a real run on real compute. Keep a
       dedicated sample for each tool so changing one demo cannot silently
       change another. The humanizer uses the same 90-word AI-flavoured text
       as the detector; the grammar text packs its mistakes into four
       sentences. */
    /* One demo per tool per language the page is published in. A visitor on
       /es who presses the button and is handed English has been given a demo
       of a tool that cannot help them; the Spanish grammar text carries
       mistakes a Spanish writer actually makes, not translated English ones;
       the Portuguese ones, the mistakes a Brazilian writer makes. */
    const samplesByLanguage = {
        humanize: {
            en: `<p>In today’s rapidly evolving digital landscape, artificial intelligence has become an indispensable tool for businesses of all sizes. It is important to note that companies leveraging these technologies often experience significant improvements in operational efficiency. Moreover, the implementation of automated solutions allows organizations to streamline their workflows and reduce unnecessary costs. However, it is crucial to remember that technology alone cannot guarantee success. Ultimately, businesses must foster a culture of innovation, ensuring that employees are properly trained and motivated to truly embrace the transformative potential of these powerful digital tools.</p>`,
            es: `<p>En el panorama digital actual, que evoluciona con gran rapidez, la inteligencia artificial se ha convertido en una herramienta indispensable para las empresas de todos los tamaños. Es importante señalar que las compañías que aprovechan estas tecnologías suelen experimentar mejoras significativas en su eficiencia operativa. Además, la implementación de soluciones automatizadas permite a las organizaciones optimizar sus flujos de trabajo y reducir costes innecesarios. Sin embargo, resulta fundamental recordar que la tecnología por sí sola no garantiza el éxito. En última instancia, las empresas deben fomentar una cultura de innovación, asegurando que los empleados estén debidamente formados y motivados para aprovechar todo el potencial transformador de estas poderosas herramientas digitales.</p>`,
            'pt-br': `<p>No cenário digital atual, que evolui rapidamente, a inteligência artificial tornou-se uma ferramenta indispensável para empresas de todos os portes. É importante ressaltar que as empresas que aproveitam essas tecnologias costumam obter melhorias significativas em sua eficiência operacional. Além disso, a implementação de soluções automatizadas permite que as organizações otimizem seus fluxos de trabalho e reduzam custos desnecessários. No entanto, é fundamental lembrar que a tecnologia, por si só, não garante o sucesso. Em última análise, as empresas devem fomentar uma cultura de inovação, garantindo que os colaboradores estejam devidamente capacitados e motivados para aproveitar todo o potencial transformador dessas poderosas ferramentas digitais.</p>`,
        },
        paraphraser: {
            en: `<p>In today’s rapidly evolving digital landscape, artificial intelligence plays a pivotal role in how organizations operate. It is important to note that using innovative technology can significantly enhance productivity and streamline workflows. Moreover, teams that embrace these tools can navigate complex challenges and deliver consistent value across the organization.</p>`,
            es: `<p>En el panorama digital actual, que evoluciona con gran rapidez, la inteligencia artificial desempeña un papel fundamental en el funcionamiento de las organizaciones. Es importante señalar que el uso de tecnología innovadora puede mejorar notablemente la productividad y optimizar los flujos de trabajo. Además, los equipos que adoptan estas herramientas pueden afrontar retos complejos y aportar un valor constante en toda la organización.</p>`,
            'pt-br': `<p>No cenário digital atual, que evolui rapidamente, a inteligência artificial desempenha um papel fundamental no funcionamento das organizações. É importante ressaltar que o uso de tecnologia inovadora pode aumentar significativamente a produtividade e otimizar os fluxos de trabalho. Além disso, as equipes que adotam essas ferramentas conseguem enfrentar desafios complexos e gerar valor de forma consistente em toda a organização.</p>`,
        },
        grammar: {
            en: `<p>Yesterday me and my freind goes to the new coffee shop on main street. The barista, who were very nice, recommended a latte, but, I didn’t liked it. Their was too much sugar in it, and the music were really loud. We decided to leave and than go home.</p>`,
            es: `<p>Ayer yo y mi amigo fuimos a la cafetería nueva de la calle principal. El barista, que era muy amable, nos recomendo un latte, pero a mi no me gusto. Habian demasiado azúcar, y la musica estaba muy alta. Decidimos irnos y despues ir a casa.</p>`,
            'pt-br': `<p>Ontem eu e meu amigo fomos na cafeteria nova da rua principal. O barista, que era muito simpatico, nos recomendou um latte, mais eu não gostei. Haviam muitas pessoas, tinha açucar demais e a musica estava muito alta. Decidimos ir embora e voltar pra casa.</p>`,
        },
    };

    const pageLanguage = (document.documentElement.lang || 'en').toLowerCase();
    const sampleLanguage = pageLanguage.slice(0, 2);
    const sampleFor = tool => samplesByLanguage[tool][pageLanguage] || samplesByLanguage[tool][sampleLanguage] || samplesByLanguage[tool].en;

    const humanizerSample = sampleFor('humanize');
    const paraphraserSample = sampleFor('paraphraser');
    const grammarSample = sampleFor('grammar');
    const allSamples = [
        humanizerSample,
        grammarSample,
    ];

    document.body.addEventListener('click', function (e) {
        const btn = e.target.closest('.try-sample');
        if (!btn) return;

        const wrapper = btn.closest('.form-floating');
        const idx = wrapper?.dataset?.quillIndex;
        const editorType = wrapper?.querySelector('[data-editor-type]')?.dataset.editorType;

        const samplesByType = {
            humanize: humanizerSample,
            grammar: grammarSample,
            paraphraser: paraphraserSample,
        };

        if (typeof idx === 'undefined') return;

        let sampleHtml = '';

        if (typeof idx !== 'undefined') {
            sampleHtml = allSamples[idx];
        }

        if (editorType in samplesByType) {
            sampleHtml = samplesByType[editorType];
        }

        if (sampleHtml) {
            quillInstances[idx]?.setHTML(sampleHtml);
        }
    });

    /* An uploaded file is not an error when it runs long — it is a file that
       needs cutting. The limit is whatever the pane already prints next to the
       counter, so the tools stay in step with the settings behind them. */
    function paneWordLimit(pane) {
        const el = pane?.querySelector('.originalWordsLimit');
        const n = parseInt((el?.textContent || '').replace(/[^\d]/g, ''), 10);
        return Number.isFinite(n) && n > 0 ? n : 0;
    }

    /* Cut at a word boundary, keeping the original spacing and line breaks up
       to that point — the same counting as the footer, so what lands in the
       editor reads exactly at the limit and not one word over. */
    function truncateToWords(text, limit) {
        const src = text || '';
        if (!limit || getSmartWordCount(src) <= limit) return src;

        const isCJK = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/u.test(src);
        if (isCJK && typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
            const hasHira = /\p{Script=Hiragana}/u.test(src), hasKata = /\p{Script=Katakana}/u.test(src);
            const locale = hasHira || hasKata ? 'ja' : (/\p{Script=Hangul}/u.test(src) ? 'ko' : 'zh-Hans');
            const seg = new Intl.Segmenter(locale, { granularity: 'word' });
            let seen = 0, end = 0;
            for (const s of seg.segment(src)) {
                if (!s.isWordLike) continue;
                seen++;
                end = s.index + s.segment.length;
                if (seen >= limit) break;
            }
            return src.slice(0, end).trimEnd();
        }

        const re = /\S+/gu;
        let seen = 0, end = 0, m;
        while ((m = re.exec(src)) !== null) {
            seen++;
            end = m.index + m[0].length;
            if (seen >= limit) break;
        }
        return src.slice(0, end).trimEnd();
    }

    function getSmartWordCount(text) {
        const t = (text || '').trim();

        const base = t ? t.split(/\s+/u).filter(Boolean).length : 0;

        const hasHan = /\p{Script=Han}/u.test(t);
        const hasHira = /\p{Script=Hiragana}/u.test(t);
        const hasKata = /\p{Script=Katakana}/u.test(t);
        const hasHang = /\p{Script=Hangul}/u.test(t);
        const isCJK = hasHan || hasHira || hasKata || hasHang;

        if (!isCJK) return base;

        if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
            const locale = hasHira || hasKata ? 'ja' : (hasHang ? 'ko' : 'zh-Hans');
            const seg = new Intl.Segmenter(locale, { granularity: 'word' });
            let count = 0;
            for (const s of seg.segment(t)) {
                if (s.isWordLike) count++;
            }
            return Math.max(base, count);
        }

        if ((hasHira || hasKata) && typeof TinySegmenter !== 'undefined') {
            try {
                const ts = new TinySegmenter();
                const jaCount = ts.segment(t).length;
                return Math.max(base, jaCount);
            } catch (_) {}
        }

        const cjkChars = (t.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu) || []).length;
        const approx = Math.ceil(cjkChars / 2.5);
        return Math.max(base, approx);
    }

    window.addEventListener('resize', changeVisibleStylesCount);
    /* WebKit sizes the panes' grid rows from before a window resize for a
       while after it: resized from a desktop to a stacked width, the result
       pane kept its desktop row height, its content ran out of it and the
       footer sat over the disclaimer (Safari, tester, Oct 2026; reproduced
       in WebKit, where a plain reflow does not clear it). Re-setting the row
       template once the resize is over does. */
    let gridNudgeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(gridNudgeTimer);
        gridNudgeTimer = setTimeout(() => {
            document.querySelectorAll('.tool .fields.in').forEach((grid) => {
                grid.style.gridTemplateRows = 'auto';
                void grid.offsetHeight;
                grid.style.gridTemplateRows = '';
            });
        }, 120);
    });
    changeVisibleStylesCount();

    const radiosQuillTab = document.querySelectorAll('#quillTab input[type="radio"]');

    radiosQuillTab?.forEach(radio => {
        radio.addEventListener('change', function () {
            const links = document.querySelectorAll('#quillTab .nav-link');
            links.forEach(link => link.classList.remove('active'));
            const navLink = this.closest('.nav-link');
            if (navLink) {
                navLink.classList.add('active');
            }
        });
    });

    window.addEventListener('beforeunload', function (e) {
        const quillOutput = document.getElementById('quillOutput');
        const contentOutput = quillOutput?.innerText?.trim();
        if (contentOutput && contentOutput != __('content.new_text')) {
            document.body.classList.remove('modal-open');
            e.preventDefault();
            e.returnValue = '';
        }
    });

    const header = document.querySelector('#header .inner');
    const topSection = document.querySelector('.top');

    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const topHeight = topSection.offsetHeight - 300;

        if (scrollY < 100) {
            header.classList.remove('out-of-view', 'fixed');
        } else if (scrollY >= 100 && scrollY < topHeight) {
            header.classList.add('out-of-view');
            header.classList.remove('fixed');
        } else if (scrollY >= topHeight) {
            header.classList.add('fixed');
        }
    }, { passive: true });

    // The burger toggle lives in ios-cleaner.js — it is loaded on every page with
    // the ds header, this file only on the tool pages.

    // Text handed over from the AI detector: the new tab reads it from a URL
    // fragment, which is neither sent to the server nor dependent on cookies or
    // storage. Keep the sessionStorage read for tabs opened by an older asset.
    // The grammar checker takes the same handoff from the detector's "Reads
    // human" card (the grammar action, tool-handoff.js); the storage
    // fallback belongs to the humanizer's older links only.
    (function initToolHandoff() {
        // the home page carries a checker pane too: the link's action decides
        const target = window.ToolHandoff?.requested('grammar') && document.getElementById('GrammarChecker')
            ? { action: 'grammar', pane: 'GrammarChecker', storage: null }
            : { action: 'humanize', pane: 'AIHumanizer', storage: 'humanizer-draft' };
        const shouldRun = window.ToolHandoff?.requested(target.action)
            || (target.storage && /[?&]humanize=1(&|$)/.test(window.location.search));
        let draft = window.ToolHandoff?.consume(target.action) || null;
        if (!draft && target.storage) {
            try {
                draft = sessionStorage.getItem(target.storage);
                if (draft) sessionStorage.removeItem(target.storage);
            } catch (err) {}
        }
        if (!draft) return;

        const editor = getQuillForType(target.action === 'grammar' ? 'grammar' : 'humanize');
        if (!editor) return;
        editor.setText(draft);

        if (!shouldRun || window.TERMS_ACCEPTANCE_REQUIRED) return;
        // drop the flag so a reload doesn't spend another run
        window.history.replaceState(null, '', window.location.pathname + window.location.hash);

        const pane = document.getElementById(target.pane);
        pane?.closest('.tool')?.scrollIntoView({ block: 'start' });
        pane?.querySelector('.submitQuill')?.click();
    })();

    // Result note CTA: put the text in the fragment before the anchor's normal
    // target=_blank navigation. This works in iOS Safari without relying on the
    // timing of sessionStorage cloning, and rel=noopener can stay enabled.
    document.addEventListener('click', function (e) {
        const cta = e.target.closest('.rn-cta');
        if (!cta || !cta.href) return;

        const output = cta.closest('.humanResult')?.querySelector('.quillOutput');
        // block-by-block, not innerText: the latter counts paragraph margins as
        // extra line breaks and the detector would receive inflated gaps
        const text = output ? readEditorText(output).trim() : '';
        if (!text) return;   // nothing to hand over — follow the link as usual

        if (window.ToolHandoff) {
            cta.href = window.ToolHandoff.makeUrl(cta.href, 'check', text);
            return;
        }

        // Backward-compatible fallback if the small helper failed to load.
        try {
            sessionStorage.setItem('ai-detector-handoff', text);
            cta.href += (cta.href.includes('?') ? '&' : '?') + 'check=1';
        } catch (err) {}
    });

    // Stream

    function now() {
        return new Date().toLocaleTimeString('en-GB', { hour12: false });
    }

    let quillTabActive = true;
    document.addEventListener("visibilitychange", function() {
        quillTabActive = document.visibilityState === 'visible';
    });

    function disableLeftEditor(quill) {
        document.querySelectorAll('.remove-text').forEach(el => {
            el.setAttribute('disabled', 'disabled');
        });
        document.querySelectorAll('.submitQuill').forEach(el => {
            el.setAttribute('disabled', 'disabled');
            el.classList.add('active-geenration');
        });
        quill?.disable();
        // A previous run may have left the result panel filled: Copy Text must
        // not be clickable while a new run is streaming into it.
        document.querySelectorAll('.copyBtn button').forEach(el => {
            el.setAttribute('disabled', 'disabled');
        });
        const tabs = document.querySelectorAll('#quillTab .nav-link');
        tabs.forEach(el => {
            el.classList.add('disabled');
            const input = el.querySelector('input');
            if (input) input.setAttribute('disabled', 'disabled');
        });
    }

    function enableLeftEditor(quill) {
        document.querySelectorAll('.remove-text').forEach(el => {
            el.removeAttribute('disabled');
        });
        document.querySelectorAll('.submitQuill').forEach(el => {
            el.removeAttribute('disabled');
            el.classList.remove('active-geenration');
        });
        quill?.enable();
        // Re-enable Copy Text only where the output actually has content
        // (covers error paths where the previous result is still shown).
        document.querySelectorAll('.quillOutput, #quillGenOutput').forEach(el => {
            updateCopyButtonVisibility(el);
        });
        const tabs = document.querySelectorAll('#quillTab .nav-link');
        tabs.forEach(el => {
            el.classList.remove('disabled');
            const input = el.querySelector('input');
            if (input) input.removeAttribute('disabled');
        });
    }

    const numWordsInputGlob = document.querySelector('#numWords');

    if(numWordsInputGlob) {
        const parentDropdownGlob = numWordsInputGlob.parentElement.parentElement.parentElement;
        const minValue = Number(numWordsInputGlob.getAttribute('min'));
        const maxValue = Number(numWordsInputGlob.getAttribute('max'));
        const allStylesGlob = parentDropdownGlob.querySelectorAll('.w-option');

        numWordsInputGlob.addEventListener('input', function () {
            let val = Number(this.value);
            if (val > maxValue) {
                this.value = maxValue;
                parentDropdownGlob.querySelector('.wStyle').innerText = formatCount(maxValue);

                allStylesGlob.forEach(function(el) {
                    el.setAttribute('data-selected', false);

                    if(Number(el.getAttribute('data-value')) == maxValue) {
                        el.setAttribute('data-selected', true);
                    }
                })
            }
        });

        numWordsInputGlob.addEventListener('change', function () {
            let val = Number(this.value);

            if (val < minValue) {
                this.value = minValue;
                parentDropdownGlob.querySelector('.wStyle').innerText = formatCount(minValue);

                allStylesGlob.forEach(function(el) {
                    el.setAttribute('data-selected', false);

                    if(Number(el.getAttribute('data-value')) == minValue) {
                        el.setAttribute('data-selected', true);
                    }
                })
            } else {
                parentDropdownGlob.querySelector('.wStyle').innerText = formatCount(val);

                allStylesGlob.forEach(function(el) {
                    el.setAttribute('data-selected', false);

                    if(Number(el.getAttribute('data-value')) == val) {
                        el.setAttribute('data-selected', true);
                    }
                })
            }
        });
    }

    /* Humanize writing style, now the same pill row the paraphraser uses: the
       picked pill writes #humanizeStyle, which is what the submit reads. The
       values ("casual" / "academic") are the ones the old dropdown carried in
       data-value, so nothing changes for the request. */
    const humanizeStyleTabs = document.getElementById('humanizeStyleTabs');
    if (humanizeStyleTabs) {
        humanizeStyleTabs.addEventListener('click', function (event) {
            const pill = event.target.closest('[data-humanize-style]');
            if (!pill) return;
            humanizeStyleTabs.querySelectorAll('[data-humanize-style]').forEach(function (item) {
                item.classList.toggle('active', item === pill);
            });
            const hidden = document.getElementById('humanizeStyle');
            if (hidden) hidden.value = pill.dataset.humanizeStyle;
        });
    }

    const writeStyles = document.querySelectorAll('.w-style .w-option');
    writeStyles.forEach(function(el) {
        el.addEventListener('click', function(e) {
            if(el.getAttribute('data-value') === null || el.getAttribute('data-disabled') === 'true') {
                return;
            }

            const targetStyle = e.currentTarget;
            const parentDropdown = targetStyle.parentElement.parentElement;
            const allStyles = parentDropdown.querySelectorAll('.w-option');

            allStyles.forEach(function(el) {
                el.setAttribute('data-selected', false);
            })

            targetStyle.setAttribute('data-selected', true);
            const selectedStyleTitle = targetStyle.querySelector('.name')?.innerText;
            const selectedStyleIcon = targetStyle.querySelector('.emoji')?.getAttribute('data-icon');
            const numWordsInput = parentDropdown.querySelector('#numWords');

            if(selectedStyleTitle) {
                parentDropdown.querySelector('.wStyle').innerText = selectedStyleTitle;

                // the label is grouped for reading (1.000); the value is the number
                if(numWordsInput) {
                    numWordsInput.value = Number(targetStyle.getAttribute('data-value'));
                }
            }
            if(selectedStyleIcon) {
                parentDropdown.querySelector('.dropdown-toggle').setAttribute('data-icon', selectedStyleIcon);
            }
        })
    })

    const closeHeaderBtns = document.querySelectorAll('.writer-header .modal-close');
    closeHeaderBtns.forEach(closeHeader => {
        closeHeader?.addEventListener('click', function(e) {
            const parentWrap = e.currentTarget.closest('.writer-header');
            parentWrap.classList.add('closed');
        });
    })

    function showForm(formIdToShow) {
        document.querySelectorAll('.form-glass').forEach((form) => {
            if (form.id === formIdToShow) {
                form.classList.add('in');
            } else {
                form.classList.remove('in');
            }
        });

        document.querySelectorAll('.humanizer-disclaimer').forEach((el) => {
            el.hidden = formIdToShow !== 'AIHumanizer';
        });

        if (formIdToShow === 'AIParaphraser') {
            initParaphraserDropzone();
        }

        // The pane just became visible (display:none before) — level it now.
        requestAnimationFrame(levelHumanizePanes);
    }

    const tabs = document.querySelectorAll('.switch-item');
    const bg = document.querySelector('.switch-bg');

    function moveBgTo(el) {
        const rect = el?.getBoundingClientRect();
        const parentRect = el?.parentElement.getBoundingClientRect();

        if(bg) {
            bg.style.width = rect.width - 1 + 'px';
            bg.style.transform = `translateX(${rect.left - parentRect.left}px)`;
        }
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            const tabControlId = tab.getAttribute('data-control');
            const tabFormType = tab.getAttribute('data-form-type');
            const formElement = document.getElementById('quillForm');
            if (formElement) formElement.setAttribute('data-form-type', tabFormType);
            showForm(tabControlId);
            moveBgTo(tab);
        });
    });

    const activeSwitch = document.querySelector('.switch-item.active');
    if (activeSwitch) {
        moveBgTo(activeSwitch);
        window.addEventListener('resize', () => moveBgTo(document.querySelector('.switch-item.active')));
    }

    // Init dropzone whenever it exists (standalone /ai-paraphraser page or main page); idempotent inside init
    if (document.getElementById('docDropzone')) {
        if (typeof window.Dropzone !== 'undefined') {
            initParaphraserDropzone();
        } else {
            var dropzoneSrc = document.querySelector('meta[name="dropzone-src"]')?.getAttribute('content');
            if (dropzoneSrc) {
                var dropzoneScript = document.createElement('script');
                dropzoneScript.src = dropzoneSrc;
                dropzoneScript.onload = function () { initParaphraserDropzone(); };
                document.head.appendChild(dropzoneScript);
            }
        }
    }

    const radios = document.querySelectorAll('input[name="type_generation"]');
    const titleInput = document.getElementById('GenerationTitle');
    const titleTextarea = document.getElementById('GenerationDescription');

    if(titleInput && titleTextarea) {
        const basePlaceholder = titleInput.getAttribute('placeholder');
        const baseDescrPlaceholder = titleTextarea.getAttribute('placeholder');


        function getSelectedLabelText() {
            const radio = document.querySelector('input[name="type_generation"]:checked');
            const label = document.querySelector(`label[for="${radio.id}"]`);

            let text = Array.from(label.childNodes)
                .filter(node => node.nodeType === Node.TEXT_NODE)
                .map(node => node.textContent.trim())
                .join(' ');

            return text.trim();
        }

        function updatePlaceholder() {
            const typeText = getSelectedLabelText();
            titleInput.placeholder = basePlaceholder.replace('{{type}}', typeText);
            titleTextarea.placeholder = baseDescrPlaceholder.replace('{{type}}', typeText);
        }

        radios.forEach(radio => radio.addEventListener('change', updatePlaceholder));
        updatePlaceholder();
    }

    function initTabs() {
        const tabs = document.querySelectorAll('.tabs .tab');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                const tabControlId = tab.getAttribute('data-control');
                const tabFormType = tab.getAttribute('data-form-type');
                const formElement = document.getElementById('quillForm');
                formElement.setAttribute('data-form-type', tabFormType);
                showForm(tabControlId);
                moveBgTo(tab);
            });
        });
    }

    // initTabs();

    function getParseDocumentUrl() {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const firstPart = pathParts[0];
        const isLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(firstPart);
        return isLocale ? `/${firstPart}/parse-document` : '/parse-document';
    }

    function initParaphraserDropzone() {
        if (dzInstance) return;
        if (typeof window.Dropzone === 'undefined') return;

        const dropzoneEl = document.getElementById('docDropzone');
        const errorEl = document.getElementById('uploadError');
        const spinnerEl = dropzoneEl?.querySelector('.dropzone-spinner');
        const wrapper = document.getElementById('AIParaphraser') || dropzoneEl?.closest('.fields');
        const blockWithDropzone = dropzoneEl?.closest('.original-block');
        const removeText = wrapper?.querySelector('.remove-text');
        const customPlaceholder = wrapper?.querySelector('.custom-placeholder');
        const submitBtn = (blockWithDropzone || wrapper)?.querySelector('.submitQuill');
        const wordCountEl = (blockWithDropzone || wrapper)?.querySelector('.quillWordCount');
        const quill = getQuillForType('paraphraser');

        if (!dropzoneEl) return;

        const dropTextEl = dropzoneEl.querySelector('.drop-text');
        dropTextEl.dataset.originalText = dropTextEl.textContent;

        window.Dropzone.autoDiscover = false;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

        dzInstance = new window.Dropzone(dropzoneEl, {
            url: getParseDocumentUrl(),
            paramName: 'file',
            maxFiles: 1,
            acceptedFiles: '.pdf,.doc,.docx,.txt',
            autoProcessQueue: true,
            headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
            params: csrfToken ? { _token: csrfToken } : {},

            accept(file, done) {
                const maxSize = 10 * 1024 * 1024;
                if (file.size > maxSize) {
                    done(typeof __ !== 'undefined' && __('content.document_too_large') ? __('content.document_too_large') : 'File is too large. Maximum size is 10 MB.');
                    return;
                }
                const allowed = [
                    'application/pdf',
                    'text/plain',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ];
                const ok = allowed.includes(file.type) || (file.type && file.type.indexOf('text/plain') === 0);
                if (!ok) {
                    done('unsupported');
                } else {
                    done();
                }
            }
        });

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.uploadFile button, .uploadDocTrigger');
            if (!btn || !dzInstance) return;
            const dropzoneBlock = document.getElementById('docDropzone')?.closest('.original-block');
            if (!dropzoneBlock || !dropzoneBlock.contains(btn)) return;
            e.preventDefault();
            e.stopPropagation();
            const dzEl = document.getElementById('docDropzone');
            if (dzInstance.hiddenFileInput) {
                dzInstance.hiddenFileInput.click();
            } else if (dzEl) {
                dzEl.click();
            }
        }, true);

        dzInstance.on('addedfile', (file) => {
            if (dzInstance.files.length > 1) {
                dzInstance.removeFile(dzInstance.files[0]);
            }
            const name = file.name;
            dropTextEl.textContent = name;
            dropzoneEl.classList.remove('hidden');
            dropzoneEl.classList.add('dropzone-uploading');
            spinnerEl?.classList.remove('hidden');
            if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
            if (wordCountEl) wordCountEl.classList.add('hidden');
            quill.clear();
            quill.enable(false);
            customPlaceholder?.classList.add('hidden');
            removeText?.classList.add('active');
        });

        dzInstance.on('sending', () => {
            dropzoneEl.classList.add('dropzone-uploading');
            spinnerEl?.classList.remove('hidden');
        });

        dzInstance.on('success', (file, response) => {
            dropzoneEl.classList.remove('dropzone-uploading');
            spinnerEl?.classList.add('hidden');
            if (wordCountEl) wordCountEl.classList.remove('hidden');
            if (submitBtn) submitBtn.removeAttribute('disabled');
            let data = typeof response === 'string' ? (() => { try { return JSON.parse(response); } catch (_) { return null; } })() : (response || null);
            if (!data && file.xhr && file.xhr.responseText) {
                try { data = JSON.parse(file.xhr.responseText); } catch (_) {}
            }
            data = data || {};
            if (data.error) {
                if (errorEl) {
                    const textEl = errorEl.querySelector('.error-text');
                    if (textEl) textEl.textContent = data.message || '';
                    errorEl.classList.remove('hidden');
                    setTimeout(() => errorEl.classList.add('hidden'), 3000);
                }
                dzInstance.removeFile(file);
                dropzoneEl.classList.add('hidden');
                dropTextEl.textContent = dropTextEl.dataset.originalText;
                removeText?.classList.remove('active');
                customPlaceholder?.classList.remove('hidden');
                blockWithDropzone?.classList.remove('paraphraser-drag-over');
                paraphraserHideBlockContent(false);
                if (quill) quill.enable(true);
                return;
            }
            const html = data.html || '';
            const text = data.text || '';
            dzInstance.removeFile(file);
            dropzoneEl.classList.add('hidden');
            dropTextEl.textContent = dropTextEl.dataset.originalText;
            removeText?.classList.remove('active');
            customPlaceholder?.classList.remove('hidden');
            blockWithDropzone?.classList.remove('paraphraser-drag-over');
            paraphraserHideBlockContent(false);
            const qEnable = getQuillForType('paraphraser');
            if (qEnable) qEnable.enable(true);

            function insertDocumentContent() {
                const q = getQuillForType('paraphraser');
                if (!q) return;
                const pane = document.getElementById('AIParaphraser');
                // A file the extractor found no text in comes back as a success
                // with nothing in it. Silence here looked like a broken upload,
                // so it uses the same red line the other upload errors use.
                const plainCheck = (text || '').trim() || html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
                if (!plainCheck) {
                    showLimitModal(__('content.document_no_text_title'), __('content.document_no_text'));
                    return;
                }
                const limit = paneWordLimit(pane);
                const plain = text || html.replace(/<[^>]*>/g, ' ');
                const overLimit = limit && getSmartWordCount(plain) > limit;
                if (html && !overLimit) {
                    q.setHTML(html);
                } else {
                    q.setText(truncateToWords(plain, limit));
                }
                if (overLimit) {
                    showLimitModal(
                        __('content.document_trimmed_title').replace(/:limit/g, formatCount(limit)),
                        __('content.document_trimmed').replace(/:limit/g, formatCount(limit))
                    );
                }
            }

            setTimeout(insertDocumentContent, 0);
        });

        dzInstance.on('error', (file, errorMessage, xhr) => {
            dropzoneEl.classList.remove('dropzone-uploading');
            spinnerEl?.classList.add('hidden');
            if (wordCountEl) wordCountEl.classList.remove('hidden');
            if (submitBtn) submitBtn.removeAttribute('disabled');
            let msg = errorMessage;
            if (xhr && xhr.responseText) {
                try {
                    const data = JSON.parse(xhr.responseText);
                    if (data.message) msg = data.message;
                } catch (_) {}
            }
            if (errorEl) {
                const textEl = errorEl.querySelector('.error-text');
                if (textEl) textEl.textContent = msg;
                errorEl.classList.remove('hidden');
                setTimeout(() => errorEl.classList.add('hidden'), 3000);
            }
            dzInstance.removeFile(file);
            dropzoneEl.classList.add('hidden');
            dropTextEl.textContent = dropTextEl.dataset.originalText;
            removeText?.classList.remove('active');
            customPlaceholder?.classList.remove('hidden');
            blockWithDropzone?.classList.remove('paraphraser-drag-over');
            paraphraserHideBlockContent(false);
            quill.enable(true);
        });

        dzInstance.on('removedfile', () => {
            if (dzInstance.files.length === 0) {
                dropzoneEl.classList.remove('dropzone-uploading');
                spinnerEl?.classList.add('hidden');
                if (wordCountEl) wordCountEl.classList.remove('hidden');
                if (submitBtn) submitBtn.removeAttribute('disabled');
                dropTextEl.textContent = dropTextEl.dataset.originalText;
                removeText?.classList.remove('active');
                dropzoneEl.classList.add('hidden');
                customPlaceholder?.classList.remove('hidden');
                blockWithDropzone?.classList.remove('paraphraser-drag-over');
                paraphraserHideBlockContent(false);
                quill.enable(true);
            }
        });

        let paraphraserLeaveTimeout = null;
        const PARAPHRASER_LEAVE_MS = 100;
        let paraphraserDragCounter = 0;

        function paraphraserHideBlockContent(hide) {
            const editorContainer = blockWithDropzone?.querySelector('#quillParaphraserContainer, .quill-editor-container');
            if (!editorContainer) return;
            if (hide) {
                editorContainer.style.color = '#fff';
            } else {
                editorContainer.style.removeProperty('color');
            }
        }

        function paraphraserClearDragOver() {
            if (dropzoneEl.classList.contains('dropzone-uploading')) return;
            blockWithDropzone?.classList.remove('paraphraser-drag-over');
            paraphraserHideBlockContent(false);
            dropzoneEl.classList.add('hidden');
            if (quill && quill.getText().trim().length === 0) {
                customPlaceholder?.classList.remove('hidden');
            } else {
                customPlaceholder?.classList.add('hidden');
            }
            if (paraphraserLeaveTimeout) {
                clearTimeout(paraphraserLeaveTimeout);
                paraphraserLeaveTimeout = null;
            }
        }

        function paraphraserShowDragOver() {
            errorEl?.classList.add('hidden');
            dropzoneEl.classList.remove('hidden');
            customPlaceholder?.classList.add('hidden');
            blockWithDropzone?.classList.add('paraphraser-drag-over');
            paraphraserHideBlockContent(true);
        }

        document.addEventListener('dragenter', (e) => {
            if (!e.dataTransfer?.types.includes('Files')) return;
            if (!blockWithDropzone || !blockWithDropzone.contains(e.target)) return;
            paraphraserDragCounter++;
            if (paraphraserLeaveTimeout) {
                clearTimeout(paraphraserLeaveTimeout);
                paraphraserLeaveTimeout = null;
            }
            paraphraserShowDragOver();
        }, true);

        document.addEventListener('dragover', (e) => {
            if (e.dataTransfer?.types.includes('Files') && blockWithDropzone?.contains(e.target)) {
                errorEl?.classList.add('hidden');
                if (paraphraserLeaveTimeout) {
                    clearTimeout(paraphraserLeaveTimeout);
                    paraphraserLeaveTimeout = null;
                }
            }
        }, true);

        document.addEventListener('dragleave', (e) => {
            if (!blockWithDropzone) return;
            const related = e.relatedTarget;
            const leftBlock = related == null || !blockWithDropzone.contains(related);
            paraphraserDragCounter = Math.max(0, paraphraserDragCounter - 1);
            if (!leftBlock) {
                if (paraphraserDragCounter > 0) return;
            }
            if (paraphraserLeaveTimeout) clearTimeout(paraphraserLeaveTimeout);
            paraphraserLeaveTimeout = setTimeout(() => {
                paraphraserLeaveTimeout = null;
                paraphraserDragCounter = 0;
                paraphraserClearDragOver();
            }, PARAPHRASER_LEAVE_MS);
        }, true);

        document.addEventListener('drop', () => {
            paraphraserDragCounter = 0;
            if (paraphraserLeaveTimeout) {
                clearTimeout(paraphraserLeaveTimeout);
                paraphraserLeaveTimeout = null;
            }
            setTimeout(paraphraserClearDragOver, 50);
        }, true);

        document.addEventListener('dragend', () => {
            paraphraserDragCounter = 0;
            if (paraphraserLeaveTimeout) {
                clearTimeout(paraphraserLeaveTimeout);
                paraphraserLeaveTimeout = null;
            }
            setTimeout(paraphraserClearDragOver, 50);
        });

        removeText?.addEventListener('click', () => {
            if (dzInstance) {
                dzInstance.removeAllFiles(true);
            }
        });
    }

    // Quick actions under the editor (every tool pane): "Paste here" for all,
    // "Upload file" via .uploadDocBtn/.humanizeFileInput on the humanize pane
    // (the paraphraser upload goes through its dropzone .uploadDocTrigger).
    // The upload reuses the paraphraser's parse-document endpoint.
    (function initQuickActions() {
        [
            { paneId: 'AIHumanizer', type: 'humanize' },
            { paneId: 'GrammarChecker', type: 'grammar' },
            { paneId: 'AIParaphraser', type: 'paraphraser' },
        ].forEach(initPaneQuickActions);

    function initPaneQuickActions({ paneId, type }) {
        const pane = document.getElementById(paneId);
        const editor = getQuillForType(type);
        if (!pane || !editor) return;

        const pasteBtn = pane.querySelector('.pasteTextBtn');
        const uploadBtn = pane.querySelector('.uploadDocBtn');
        const fileInput = pane.querySelector('.humanizeFileInput');
        const spinner = pane.querySelector('.editor-actions .dropzone-spinner');

        const pasteHint = pane.querySelector('.paste-hint');
        let pasteHintTimer;

        function showPasteHint() {
            if (!pasteHint) return;
            const isMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
            pasteHint.textContent = __('content.paste_hint').replace(':keys', isMac ? '⌘V' : 'Ctrl+V');
            pasteHint.classList.remove('hidden');
            clearTimeout(pasteHintTimer);
            pasteHintTimer = setTimeout(() => pasteHint.classList.add('hidden'), 3000);
        }

        pasteBtn?.addEventListener('click', async () => {
            // Requires a secure context (HTTPS/localhost). Firefox settles the
            // read on its own "Paste" confirmation, so it is the fast path.
            // Chromium gates readText() behind a clipboard-read bubble and
            // leaves the promise pending for as long as that bubble sits
            // unanswered (forks such as Vivaldi may never grant it at all) —
            // without racing a timeout the button did nothing there, not even
            // fall through to the Ctrl+V hint.
            if (navigator.clipboard && navigator.clipboard.readText) {
                let waitTimer;
                const read = navigator.clipboard.readText().then(normalizePastedText, () => '');
                const text = await Promise.race([
                    read,
                    new Promise(resolve => { waitTimer = setTimeout(() => resolve(null), 1200); })
                ]);
                clearTimeout(waitTimer);
                if (text && text.trim()) {
                    editor.setText(text);
                    editor.focus();
                    enforcePastedLimit(editor.root);
                    return;
                }
                if (text === null) {
                    // permission still undecided: hint now, but honour a late
                    // grant while the user has not put anything in themselves
                    read.then(late => {
                        if (!late.trim() || editor.getText().trim()) return;
                        editor.setText(late);
                        editor.focus();
                        enforcePastedLimit(editor.root);
                        clearTimeout(pasteHintTimer);
                        pasteHint?.classList.add('hidden');
                    });
                }
            }
            // Clipboard unreadable (insecure context / permission denied /
            // empty) — put the caret in the editor; a synthetic paste goes
            // through our paste handler, otherwise show the ⌘V/Ctrl+V hint.
            editor.focus();
            try {
                if (document.execCommand('paste')) return;
            } catch (_) {}
            showPasteHint();
        });

        uploadBtn?.addEventListener('click', () => fileInput?.click());

        fileInput?.addEventListener('change', async () => {
            const file = fileInput.files?.[0];
            fileInput.value = '';
            if (!file) return;

            if (file.size > 10 * 1024 * 1024) {
                showLimitModal(__('content.document_problem_title'), __('content.document_too_large'));
                return;
            }
            const allowedTypes = [
                'application/pdf',
                'text/plain',
                'text/markdown',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ];
            if (!allowedTypes.includes(file.type) && !/\.(pdf|docx?|txt|md)$/i.test(file.name)) {
                showLimitModal(__('content.document_problem_title'), __('content.document_unsupported'));
                return;
            }

            spinner?.classList.remove('hidden');
            uploadBtn?.setAttribute('disabled', 'disabled');
            try {
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                const formData = new FormData();
                formData.append('file', file);
                if (csrfToken) formData.append('_token', csrfToken);
                const response = await (window.csrfFetch || window.fetch)(getParseDocumentUrl(), {
                    method: 'POST',
                    headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
                    body: formData
                });
                const data = await response.json().catch(() => null);
                if (!response.ok || !data || data.error) {
                    showLimitModal(__('content.document_problem_title'), data?.message || __('content.document_unsupported'));
                    return;
                }
                // An image-only PDF extracts to nothing, and the server calls
                // that a success. Writing the empty result cleared the editor
                // and said nothing, which reads exactly like a broken upload.
                const extracted = (data.text || '').trim()
                    || (data.html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
                if (!extracted) {
                    showLimitModal(__('content.document_no_text_title'), __('content.document_no_text'));
                    return;
                }
                const limit = paneWordLimit(pane);
                // Put the document in first, then measure what actually landed:
                // a DOCX arrives as markup, and the editor's own word count of
                // it does not match the plain-text copy the server also sends —
                // measuring the wrong one let a 3,610-word file through a
                // 3,000-word cap. Over the limit, the markup is dropped for
                // plain text, since a cut mid-markup would cut a tag in half.
                if (data.html) {
                    editor.setHTML(data.html);
                } else {
                    editor.setText(data.text || '');
                }
                const inserted = editor.getText().trim();
                if (limit && getSmartWordCount(inserted) > limit) {
                    editor.setText(truncateToWords(inserted, limit));
                    showLimitModal(
                        __('content.document_trimmed_title').replace(/:limit/g, formatCount(limit)),
                        __('content.document_trimmed').replace(/:limit/g, formatCount(limit))
                    );
                }
            } catch (_) {
                showLimitModal(__('content.document_problem_title'), __('content.modal_error_descr'));
            } finally {
                spinner?.classList.add('hidden');
                uploadBtn?.removeAttribute('disabled');
            }
        });
    }
    })();

    /* The reviews video's cover-until-clicked handler moved to
       video-facade.js, so the detector page — which does not load this
       file — can use the same one. */

});
